// en
export const locale = {
  lang: 'en-US',
  data: {
    appName: 'App name',
    layout: {
      footer: {
        aboutUs: 'About us',
        contactUs: 'Contact us',
        support: 'Support',
      },
      asideMenu: {
        Dashboard: 'Dashboard',
        Infrastructure: 'Infrastructure',
        SystemManagement: 'System management',
        SendingSystem: 'Sending system',
        Configuration: 'Configuration',
        SmsReports: 'SMS reports',
        Facility: 'Facility',
        Financial: 'Financial',
        Phonebook: 'Phonebook',
        Setting: 'Setting',
        Services: 'Services',
        whiteMessages: 'White messages',
      },
    },
    pages: {
      dashboard: {
        dailyCountChart: {
          dailySentMessageStatistics: 'Daily sent message statistics',
          lastTenDaysSentMessagesCount: 'Last ten days sent messages count',
          allCount: 'All count',
          sentCount: 'Sent count',
        },
        dailyTypeChart: {
          dailySentMessageWithTypeStatistics:
            'Daily SMS sending statistics by SMS type',
          lastTenDaysSentMessagesCountByType:
            'The number of messages sent in the last ten days by message type',
        },
        latestInformations: {
          latestNews: 'Latest news',
        },
        percentChart: {
          sentMessages: 'Sent messages',
          sentMessagesWithPercent:
            'The chart below shows the percentage of SMS sent based on the type of sending',
          SentMessagesPercent: 'Sent messages percent',
          sent: 'Sent',
          notSent: 'Not sent',
          all: 'All',
          sendType: 'Send Type',
          sentPercent: 'Sent percentage',
        },
        systemStatistics: {
          organizationInformations: 'Organ info',
          balance: 'Balance',
          lastloginTime: 'Last login time',
          lastloginIP: 'Last login ip',
        },
        todayStatistics: {
          sentSmsStatisticsWithType:
            'The statistics below show the number of last ten days text messages sent based on the type of sending.',
          sentMessages: 'Last ten days sent messages',
        },
      },
      shared: {
        helpPage: {
          menuGuide: 'Menu guide',
        },
        editSendReceiversDeliveryStatus: {
          clickHereToGetASampleFile:
            'To get the sample file <a class="tw-font-bold tw-cursor-pointer text-info" href="/assets/media/sample/sample.xlsx" download="sampleMobiles. xlsx " id="linkIdSampleMobiles">click here</a>.',
        },
        outboxMessagesDetail: {},
        outboxMessagesSendBulkDetail: {},
      },
      infrastructure: {
        setting: {
          settingForm: {
            ifNumberIsNotServiceSmsWillNotBeSentToBlackList:
              'If the selected line is not a service, <br /> SMS will not be sent to phone numbers that are in the black list.',
          },
        },
        privateNumbers: {
          privateNumbersForm: {
            oneOfTheNumbers1To9: 'One of the numbers 1 to 9',
            twoTo11Times0To9: '2 to 11 times 0 to 9',
            threeTo11Times0To9: '3 to 11 times 0 to 9',
            maximum9Times: 'Maximum 9 times?',
          },
        },
        menus: {
          menusForm: {
            downloadVideo:
              '<a target="_blank" href="{{fileUrl}}">Download video</a>',
            downloadPDF:
              '<a target="_blank" href="{{fileUrl}}">Download PDF</a>',
            downloadFile:
              '<a target="_blank" href="{{fileUrl}}">Download File</a>',
          },
        },
      },
      facility: {
        phonebook: {
          fromIndex:
            '"From index" should not be more than "number of contacts"',
          count: '"Number" should not be more than "Number of contacts"',
          both: 'Indexing is wrong',
        },
      },
      sendingSystem: {
        fastSendSmsPatternByPhonebook: {
          youAreOnlyAbleToSelectTheSMSTemplateAndYouCannotChangeTheTextOfTheMessage:
            'Note that you can only choose the SMS template and you cannot change the text of the message manually.',
          toSetTheSMSTextClickOnTheSMSTemplateButtonThenChooseYourSMStemplate:
            'To set SMS text on <b class="text-primary"> SMS template key </b><i class="mdi mdi-text-box-plus-outline text-primary tw-mx-1 mdi-20px">< Click /i> then select your SMS template <b class="!tw-text-violet-600 tw-font-semibold"> </b>',
        },
        sendBulkSms: {
          chooseAreaAndSetFilters:
            'At first, you should choose which areas you want to send SMS to and with which filters in the <b class="text-dark tw-font-black"> sending range </b> section. Note that you must specify at least one province and the type of SIM cards to which the SMS is to be sent',
          calculateNumbers:
            'After setting the filters you need from the section <b class="text-dark tw-font-black"> send details </b> once click on the button <b class="badge badge-success tw-rounded-[3px]"> calculate total count <i class="mdi mdi-calculator mdi-18px text-white"></i> </b>',
          chooseNumbersCount:
            'Then, in the section <b class="text-dark tw-font-black"> send details </b> specify how many numbers you want to send from the second row',
          addAreaToList:
            'In the last step, the area and filters you want will be added to the final list by clicking the button <b class="badge badge-navyBlue tw-rounded-[3px]"> Add <i class="mdi mdi-plus-thick mdi-18px"></i> </b>. You can do this for multiple regions',
          clickOnNext:
            'Finally, by clicking the <b class="text-dark tw-font-black"> next step </b> button, you will be transferred to SMS settings and how to send it.',
          models: {},
        },
        sendP2PSms: {
          createExcel:
            'With this service, you will be able to personalize the sent text for each mobile number. For this, it is enough to create an excel file and include the columns containing the information in it. It should be noted that the Excel file can contain different columns and you can adjust the SMS text according to the text columns. Please note that the first line of the Excel file is not read, so you can use it to insert the title.',
          tipsForExcelTable:
            'The title of the columns must be of text type, with English letters and no spaces.',
          sendWithDuplicateNumbersMsg:
            'The name of the table where the numbers are located must be Sheet1 and the column titles must be Text type, with English letters and no spaces',
        },
        sendSmartSmsConfirmRequest: {},
        sendBalkSms: {
          yourSendingIsInUpdateStatus:
            'Dear user, please note that your submission has been stopped and is in<b class="text-danger">updating</b> status. In order to continue the submission process, editing is required.',
        },
        base: {
          baseSendSMS: {
            message:
              'Dear user, please note that your submission has been stopped and is in<b class="text-danger">Updating</b> status. In order to continue the sending process, editing is required',
          },
        },
        sendSmartSmsCreateRequest: {
          sendSmartSmsAdvanceSearch: {
            searchInPeronalPlaces: 'Search in peronal places',
            personal: 'Personal',
            category: 'Category',
            publicSearch: 'Public search',
            public: 'Public',
            selectedListPublic: 'Selected public places',
            selectedListPersonal: 'Selected personal places',
          },
        },
      },
      systemManagement: {
        organizations: {
          organizationDeleteConfirmDialog:
            'All users of the organization that is deleted will also be deleted',
          justDeleteOrgan: 'Just delete the organization',
          deleteOrganAndSubsets:
            'Delete the organization and all subcategories',
          organizationsAuthenticationForm: {
            maxSizeIs200kb:
              'The maximum size of each file should not exceed 200 KB',
          },
        },
        users: {
          userForm: {
            changeNumber: 'Change number',
            changeNumberAndAuthenticate: 'Change number and authenticate',
            confirmed: 'Confirmed',
            notConfirmed: 'Not confirmed',
            userAuthMobile: {
              enterVerificationCode:
                'Enter the verification code sent to the mobile number<b class="text-info">{{mobile}}</b>',
            },
          },
          userPersonalInfo: {
            userPersonalInfoForm: {
              editPersonalInfo: 'Edit personal information',
              submitPersonalInfo: 'Registration of personal information',
            },
          },
        },
      },
      register: {
        form: {
          fields: {
            isRealPerson: 'Is real person?',
            name: 'Name',
            organName: 'Organ name',
            nationalId: 'National id',
            economicCode: 'Economic code',
            ceoName: 'Ceo name',
            ceoMobile: 'Ceo mobile',
            ceoNationalCode: 'Ceo national code',
            isForeigner: 'Is foreigner',
          },
          legends: {
            organizationInfo: '{{type}} Organization info',
            UserInfo: 'User info',
          },
          messages: {
            organizationDescription:
              'Dear user, to complete the registration process, it is necessary to enter the details of your {{type}} organization in the form below',
            userDescription:
              'Dear user, in order to finalize the registration process, it is necessary to enter your user details in the form below',
          },
        },
      },
      blackList: {
        title: 'Blacklist',
        form: {
          addTitle: 'Add to blacklist',
        },
      },
      customerDomains: {
        title: 'Customer domains',
        domainConfigurations: 'Domain configurations',
        form: {
          addTitle: 'Add domain',
          editTitle: 'Edit domain',
          detailTitle: 'Domain detail',
          domainInfo: 'Domain info',
          templateAndTheme: 'Template and theme',
          fields: {
            desktop: 'Desktop',
            loginTheme: 'Login theme',
            resellerDomain: 'Reseller domain',
            resellerIdentityDomain: 'Reseller identity domain',
            agentLogo: 'Agent logo',
            lastModified: 'Last modified',
            resellerLink: 'Link',
            dashboardMode: 'Dashboard mode',
            loginPageMode: 'Login page mode',
            primaryColor: 'Primary color',
            secondaryColor: 'Secondary color',
            enamad: 'eNamad',
          },
        },
        detailForm: {
          legend: 'Detail form',
        },
      },
      smsSenderAgents: {
        title: 'SMS sender agents',
        form: {
          addTitle: 'Add SMS sender agent',
          editTitle: 'Edit SMS sender agent',
          fields: {
            defaultNumber: 'Default number',
            type: 'Type',
            smsSenderAgentReference: 'SMS sender agent reference',
            startTime: 'Start time',
            endTime: 'End time',
            sendSmsAlert: 'Send SMS alert',
            isSendActive: 'Is send active',
            isReceiveActive: 'Is receive active',
            isSendBulkActive: 'Is send bulk active',
            sendBulkIsAutomatic: 'Send bulk is automatic',
            checkMessageId: 'Check message id',
            isSendSmartActive: 'Is send smart active',
            isActiveAllTime: 'Not considering the start and end time',
            sendLink: 'Send link',
            receiveLink: 'ReceiveLink',
            deliveryLink: 'Delivery link',
            domain: 'Domain',
            internalCredit: 'Internal credit',
            externalCredit: 'External credit',
            queueLength: 'Queue length',
            routeActive: 'Route active',
            isP2p: 'Is p2p',
            isSmpp: 'Is smpp',
            isBts: 'Is bts',
            udhLen: 'Udhlen',
            receiveInboxType: 'Receive inbox type',
          },
          legends: {
            accessInformation: 'Access information',
            generalInformation: 'General information',
            socialMediaSmartDetailsMci: 'Social media smart details mci',
            socialMediaSmartDetailsMtn: 'Social media smart details mtn',
            socialMediaSmartDetailsRightel:
              'Social media smart details rightel',
          },
        },
      },
      privateNumbers: {
        title: 'Private numbers',
        addBtns: {
          addSingle: 'Add single',
          createByRange: 'Create by range',
        },
        form: {
          addTitle: 'Add private number',
          editTitle: 'Edit private number',
          fields: {
            id: 'Id',
            priority: 'Priority',
            sendToBlackList: 'Send to blacklist',
            deliveryBase: 'Delivery base',
            checkFilter: 'Check filter',
            deliveryLevel1: 'Cost deduction based on level 1 delivery',
            deliveryLevel2: 'Cost deduction based on level 2 delivery',
            isAutomaticBulk: 'Is automatic bulk',
            confirmP2pAndDynamic: 'ConfirmP2pAndDynamicSend',
            isAutomaticGroup: 'Is automatic group',
            isSendBulk: 'Is send bulk (update number)',
            isSendGender: 'Is send gender',
            isSendGroup: 'Is send group',
            isSendPhonebook: 'Is send phonebook',
            isSendBulk2: 'Is send bulk',
            isSendApiP2P: 'Is Send Api P2P',
            isSendDynamic: 'Is Send Dynamic',
            isSendOtp: 'Is Send Otp',
            isSendP2P: 'Is Send P2P',
            isSendClub: 'Is Send Club',
            isPublic: 'Is Public',
            isSendApiSingle: 'Is Send Api Single',
            isGeneralBlackList: 'Is general blacklist',
            isSendSingle: 'Is send single',
            hasSla: 'HasSla',
            smsSenderAgentId: 'SMS sender agent id',
            smsSenderAgentName: 'SMS sender agent name',
            useForm: 'Use form',
            mask: 'Mask',
            range: 'Range',
            tryCount: 'Try count',
            expireTime: 'Expire time',
            isSendDevice: 'Is send device',
            isSendSmart: 'Is send smart',
            isNeedToSendConfirmationMessage:
              'Is need to send confirmation message',
            isSendPrivateNumberExpirationMessage:
              'Is send private number expiration message',
            isSendAlertForCreateOnlinePayment:
              'Is send alert for create online payment',
            isSendAlertForCreatePayment: 'Is send alert for create payment',
            isPostpaid: 'Is post paid',
            refundDeliveryStatusId: 'Refund delivery status',
            isCanSendFlashSms: 'Is can send flash sms',
            tag: 'Tag',
            isCanSendSmartWithoutConfirmation:
              'is can send smart without confirmation?',
            isSendOccasionPhonebook: 'Is send occasion phonebook?',
            numberStartOfRange: 'Number start of range',
            numberEndOfRange: 'Number end of range',
          },
          legends: {
            generalSettings: 'General settings',
            messageSenderInformation: 'Message sender information',
            bulkSend: 'Bulk Send',
            webServiceSend: 'Web Service Send',
            toNumberSend: 'Number to send',
          },
        },
      },
      bulkNumberInformation: {
        name: 'List of bulk numbers (update number)',
        name2: 'List of bulk numbers',
        title: 'List of bulk numbers (update number)',
        title2: 'List of bulk numbers',
        importfromfile: {
          title: 'Import from file',
          fields: {
            selectfile: 'Select file',
            empty: 'Empty',
            cellPhone: 'Cell phone',
            zipCode: 'Zip code',
            areaName: 'Area name',
            cityName: 'City name',
            stateName: 'State name',
            genderType: 'Gender type',
            guildName: 'Guild name',
            subGuildName: 'SubGuild name',
            isBlackList: 'Is blacklist',
            isBlackListLocal: 'Is blacklist local',
            mobileOperator: 'Mobile operator',
            simType: 'Sim type',
          },
        },
        deleteFromFile: {
          title: 'Delete from file',
          fields: {
            selectfile: 'Select file',
            empty: 'Empty',
            cellPhone: 'Cell phone',
          },
        },
        deleteBtns: {
          deleteMultiple: 'Delete multiple',
          deleteFromFile: 'Delete from file',
        },
        addBtns: {
          addSingle: 'Add single',
          addFromFile: 'Add from excel file',
        },
        form: {
          addTitle: 'Add number',
          legend: 'Add number',
          fields: {
            id: 'Id',
            genderType: 'Gender type',
            areaName: 'Area name',
            cityName: 'City name',
            isBlackList: 'Is blacklist',
            isBlackListLocal: 'Is blacklist local',
            mobile12: 'Mobile 12',
            mobileOperator: 'Mobile operator',
            stateName: 'State name',
            guildName: 'Guild name',
            subGuildName: 'SubGuild name',
            simType: 'Sim type',
            zipCode10: 'Zip code 10',
          },
          legends: {
            generalSettings: 'Bulk numbers list',
            generalSettings2: 'Bulk numbers list 2',
          },
        },
      },
      organizations: {
        title: 'Organizations',
        authenticatedMobile: 'Authenticated mobile',
        organizationsExcel: 'Download organizations excel',
        form: {
          addTitle: 'Add organization',
          editTitle: 'Edit organization',
          fields: {
            isRealPerson: 'Is real person',
            name: 'Name',
            workplaceTitle: 'Workplace Title',
            workplacePhone: 'Workplace Phone',
            workplaceZipCode: 'Workplace Postal Code',
            workplaceAddress: 'Workplace Address',
            organName: 'Organ name',
            nationalId: 'National id',
            economicCode: 'Economic code',
            ceoFullName: 'Ceo name',
            ceoMobile: 'Ceo mobile',
            ceoNationalCode: 'Ceo national code',
            maximumUser: 'Maximum user',
            maxOrganization: 'Max organization',
            maxCustomFiled: 'Max custom filed',
            maxPhonebook: 'Max phonebook',
            parentId: 'Parentid',
            adminUserId: 'Admin user id',
            resellerId: 'Reseller id',
            panelPrice: 'Panel price',
            groupPriceTitle: 'Group price',
            blackSenderPrivateNumberId: 'Blacklist sender',
            maximumPhoneNumber: 'Maximum phone number',
            domainId: 'DomainId',
            sendStartTime: 'Send start time',
            sendEndTime: 'Send end time',
            expireTime: 'Expire time',
            isShowGeneralNumbers: 'Display public number for users',
            isForeigner: 'Is foreigner',
            isActiveSend: 'Is active send',
            isConfirmMessage: 'Is confirm message',
            isActiveAllTime:
              'Not considering the start and end time of sending',
            isAllowLink: 'Is allowLink',
            isTax: 'Is tax',
            isAuthenticated: 'Is authenticated',
            isShowGeneralAccount: 'Display public portal for users',
            organizationDocuments: 'Organization document type',
            defineNewUser: 'Add new user',
            isCanSeePublicParentPhonebook: 'Is can see public parent phonebook',
            isSendAlertToOrganizationAdmin:
              'Is send alert to organization admin',
            isSendAlertForCreateSmartSmsRequest:
              'Is send alert for create smart sms request',
            isSendOrganizationExpirationAlertMessage:
              'Is send organization expiration alert message',
            isCanSendExtraReceivers: 'Is can send extra receivers',
            isCanSetMultipleMobileForUser:
              'Is can set multiple mobile for user?',
            enableSystemDefaultTag: 'Enable system default tag',
          },
          legends: {
            generalInformation: 'General information',
            systemInformation: 'System information',
            organizationAdminUser: 'Organization Admin',
          },
        },
        organizationAuthentication: {
          title: 'Organization authentication',
          form: {
            addTitle: 'Authentication form',
            legend: 'Authentication',
            fields: {
              organizationDocuments: 'Organization documents',
              documentStatus: 'Document status',
              image: 'Image',
              description: 'Description',
              BusinessLicense: 'Business license',
              FoundedAnnounce: 'Founded announce',
              LatestChangesAnnounce: 'Latest changes announce',
              CeoNationalCard: 'Ceo national card',
              CeoBirthCertificate: 'Ceo birth certificate',
              OptionalField1: 'Optional field 1',
              OptionalField2: 'Optional field 2',
            },
          },
        },
        organizationDocumentation: {
          title: 'Organization documents',
          form: {
            addTitle: 'Authentication confirmation',
            legend: 'Authentication confirmation form',
            fields: {
              isAuthenticated: 'Is authenticated',
              organizationDocuments: 'Organization documents',
              description: 'Description',
              status: 'Status',
              documentStatus: 'Document status',
              organizationDocument: 'Organization document',
            },
          },
        },
        organizationResellers: {
          title: 'Organization Resellers',
        },
        deleteOrganization: 'Delete organization',
        deleteOrganizationWihDescendantList:
          'Delete organization with descendant list',
      },
      organizationCustomFields: {
        title: 'Organization custom fields',
        form: {
          addTitle: 'Add field',
          editTitle: 'Edit field',
          legend: 'Field Information',
          fields: {
            CustomFieldTypes: 'Custom field types',
            nameEn: 'English name',
            nameFa: 'Persian name',
          },
        },
      },
      users: {
        name: 'Name',
        title: 'Users',
        increaseUserCreditTitle: 'Increase user credit',
        decreaseUserCreditTitle: 'Decrease user credit',
        usersExcel: 'Download excel file',
        addBtns: {
          addSingle: 'Add single',
          addFromFile: 'Add from excel file',
        },
        importfromfile: {
          title: 'Add from file',
          downloadSample: 'Download Sample',
          uploadAddDescription:
            '<p class="tw-mt-3 tw-mb-1">⁃Files with the extension <b>{{fileType}}</b> are allowed to be uploaded.</p><p class="tw-my-1"> ⁃ Please note that the first line of the Excel file is not read, so you should use it to insert the title. -pointer text-info" href="/assets/media/sample/importUsers.xlsx" download="sampleUsers.xlsx" id="linkIdSampleUsers"> Click here </a>.</p><p class= "tw-mt-3 tw-mb-1">⁃If an organization is not selected, the current organization will be considered as the user organization.</p> <p class="tw-my-1 tw-font-medium">⁃Pay attention to the file Excel, for the user in the <b class="text-danger"> first line</b>, fill in the information of the optional fields with the required information or a hyphen (-).</p>',
          fields: {
            selectfile: 'Select file',
            empty: 'Empty',
            userName: 'Username',
            nationalCode: 'National code',
            identityNumber: 'Identity number',
            firstName: 'First Name',
            lastName: 'Last name',
            fatherName: 'Father name',
            email: 'Email',
            password: 'Password',
            isForeigner: 'Is foreigner?',
            zipCode: 'Zip code',
            phone: 'Phone',
            mobile: 'Mobile',
            faxNumber: 'Fax number',
            address: 'Address',
            zoneId: 'City',
            birthDate: 'Birth date',
            expireDate: 'Expire date',
            isActiveSend: 'Is active send?',
            descriptions: 'Descriptions',
            isDefault: 'Is default?',
            roleTemplateId: 'Role format',
            isActive: 'Is Active',
            isCanSendSmartWithoutConfirmation:
              'is can send smart without confirmation?',
          },
        },
        form: {
          addTitle: 'Add user',
          editTitle: 'Edit user',
          fields: {
            foreignerCode: 'Foreigner code',
            zoneId: 'Zone id',
            password: 'Password',
            secondPassword: 'Second password',
            isAdmin: 'Is admin',
            isAuthenticatedMobile: 'Is authenticated mobile',
            roleTemplateId: 'Role template',
            nationalCode: 'National Code/Foreigner code',
            isSendSmsDescriptionRequired: 'Is send sms description required?',
            isCanSeeContactsOfPrivatePhonebooks:
              'Is can see contacts of private phonebooks',
            isCanSeeContactsOfPublicPhonebooks:
              'Is can see contacts of public phonebooks',
          },
          legends: {
            personalInformation: 'Personal information',
            systemInformation: 'System information',
            authentication: 'Authentication',
            roleInformation: 'Roles',
          },
        },
        userInfo: {
          title: 'User authentication',
          userAuthentication: {
            title: 'User authentication',
            form: {
              addTitle: 'User authentication form',
              legend: 'User authentication form',
              fields: {
                BirthCertificate: 'Birth certificate',
                NationalCard: 'National card',
                OptionalField1: 'Optional field 1',
                OptionalField2: 'Optional field 2',
                documentStatus: 'Document status',
                description: 'Description',
              },
            },
          },
          userDocumentation: {
            title: 'User documents',
            form: {
              addTitle: 'Authentication confirmation',
              legend: 'Authentication confirmation form',
              fields: {
                isAuthenticated: 'Is authenticated',
                userDocuments: 'User documents',
                description: 'Description',
                status: 'Status',
                documentStatus: 'Document status',
              },
            },
          },
        },
        personalInfo: {
          name: 'Personal info',
          title: 'Personal info',
          editTitle: 'Edit personal information',
          organizationalInfo: 'Organization info',
          personalInfo: 'Personal info',
          foreigner: 'Foreigner',
          isForeigner: 'Is foreigner',
          foreignerCode: 'Foreigner code',
          firstAlert:
            'Dear user, in order to continue the process, it is necessary to complete your personal information',
          secondAlert:
            'Your information has been successfully registered. You will be notified of the final result within the next 48 hours',
        },
      },
      activeSessions: {
        title: 'Active sessions',
      },
      formBuilderResponses: {
        responsesExcel: 'Responses excel',
      },
      userImpersonated: {
        title: 'User impersonated',
        form: {
          fields: {
            impersonatorUserName: 'Impersonator User name',
            impersonatorOrganizationName: 'Impersonator Organization Name',
            impersonatedUserName: 'Impersonated User Name',
            impersonatedOrganizationName: 'Impersonated Organization Name',
          },
        },
      },
      valueOfPurchases: {
        title: ' RFM',
        form: {
          fields: {
            totalPoint: 'Total points',
            points: 'points',
            totalUsedCredit: 'Total used credit',
            realUsedCredit: 'Real used credit',
            totalSentCount: 'Total sent count',
            realSentCount: 'Real sent count',
            totalSentParts: 'Total sent parts',
            realSentParts: 'Real sent parts',
            sendSmsFrequency: 'Send sms frequency',
            isRecentSendSmsDifferenceTillNowMoreThanFrequency:
              'Is recent send sms difference till now more than frequency',
            recentSendSms: 'Recent send sms',
            recentSendDifferenceWithFrequencyStatus:
              'Recent send difference with frequency status',
            usedCreditPerEachFrequency: 'Used credit per each frequency',
          },
        },
      },
      userValueOfPurchasePoints: {
        title: 'User value of purchase points',
        form: {
          legend: 'Point',
          addTitle: 'New point',
          editTitle: 'Edit point',
          fields: {
            point: 'Point',
            valueEndRange: 'Value end range',
            valueStartRange: 'Value start range',
            index: 'index',
          },
        },
      },
      userValueOfPurchaseStrategies: {
        title: ' RFM strategies',
        form: {
          legend: 'Strategy',
          addTitle: 'New strategy',
          fields: {
            point: 'امتیاز',
            valueEndRange: 'مقدار پایان بازه',
            valueStartRange: 'مقدار شروع بازه',
            index: 'شاخص',
            range: 'بازه',
          },
        },
      },
      userPoints: {
        title: 'User points',
        form: {
          fields: {
            totalPoint: 'Total points',
            points: 'points',
          },
        },
      },
      financial: {
        newPayment: {
          invoice: {
            sellerSpecifications: 'Seller Specifications',
            customerSpecifications: 'Customer Specifications',
            finalPayment: 'Final Payment',
            totalAmountRial: 'Total amount (rial)',
            realLegalPersonName: 'Real / Legal Person Name',
            valueAddedTaxRial: 'Value added tax (rial)',
            invoiceIssuance:
              'This proforma invoice is valid for one day from the date of issue',
            noLegalValue:
              'It lacks legal value and credibility to be announced and included in the websites of tax affairs, finance, insurance, etc',
            parliamentTax: 'Parliament tax (rial)',
          },
        },
      },
      userPasswordHistory: {
        title: 'User password history',
        form: {
          fields: {
            createdUserName: 'Editor',
          },
        },
      },
      userLogins: {
        title: 'User logins',
      },
      smartDetail: {
        title: 'Smart details',
      },
      assignNumbers: {
        title: 'Assign numbers',
        assignPrivateNumbers: {
          title: 'Assign private number',
        },
        publicReceiveKeywords: {
          title: 'Public numbers assignment',
          form: {
            editTitle: 'Edit public number assignment',
            addTitle: 'Add public number assignment',
            legend: 'Public numbers assignment',
          },
        },
        privateReceiveKeywords: {
          title: 'Numbers assignment with keyword',
          form: {
            editTitle: 'Edit public number assignment',
            addTitle: 'Public number assignment',
            legend: 'Numbers assignment with keyword',
          },
        },
        privateNumberSendLimit: {
          title: 'Assign line to user',
          form: {
            editTitle: 'Edit assigning a line to a user',
            addTitle: 'Assign a new line to the user',
            legends: {
              general: 'User line assignment information',
              sendTypesList: 'Send Types List',
              users: 'Users',
              privateNumbers: 'Numbers',
            },
            fields: {
              canSeeReceivedSms: 'Ability to view received messages',
            },
          },
        },
      },
      transferPrivateNumbers: {
        title: 'Private number assignment',
        form: {
          editTitle: 'Change ownership',
          addTitle: 'Change ownership',
          legend: 'Private number assignment',
          fields: {
            numberType: 'Number type',
            newOwner: 'New owner',
            preOwner: 'Pre owner',
            privateNumber: 'Private number',
            TransferDateTime: 'Transfer date time',
          },
        },
      },
      inboxGroups: {
        title: 'Inbox groups',
        form: {
          editTitle: 'Edit inbox group',
          addTitle: 'Add inbox group',
          legend: 'Inbox group',
          fields: {
            inboxGroupName: 'Inbox group name',
          },
        },
      },
      inboxes: {
        title: 'Inbox',
        organizationInboxesTitle: 'Organization Inboxes',
        usersInboxesTitle: 'Users Inboxes',
        addToInboxGroup: 'Add To Inbox Group',
        inboxesExcel: 'Inboxes Excel',
        form: {
          editTitle: 'Edit inbox',
          addTitle: 'Add inbox',
          legend: 'Inbox',
          changeStatusTitle: 'Change status',
          fields: {
            inboxGroupName: 'Inbox group name',
            organizationName: 'Organization name',
            receiverNumber: 'Receiver number',
            senderMobile: 'Sender mobile',
            Encoding: 'Encoding',
            smsParts: 'SMS parts',
            smsText: 'SMS text',
            isRead: 'Is read',
            dateTimeReceive: 'Date time receive',
          },
        },
      },
      customPlace: {
        title: 'Custom places',
        form: {
          editTitle: 'Edit custom place',
          addTitle: 'Add custom place',
          legend: 'Custom places',
          customPlaceCreated: 'Custom place created',
          dialogs: {
            polygonAtLeaseMostHave3Point: 'Polygon at least most have 3 points',
          },
          fields: {
            deletedAt: 'Delete dat',
            coordinates: 'Coordinates',
            deletedBy: 'Delete d by',
            isActive: 'Is active',
            parentName: 'Parent name',
            geometryType: 'Geometry type',
            cityName: 'City name',
            provinceName: 'Province name',
          },
        },
      },
      groupPrice: {
        title: 'Group prices',
        titleWithCategoryName: 'List of {{categoryName}} group price ranges',
        groupPriceCategories: {
          title: 'Group price categories',
          categoryName: 'Category name',
          groupPriceCount: 'Group price count',
          form: {
            addTitle: 'Add group price category',
            editTitle: 'Edit group price category',
          },
        },
        form: {
          legend: 'Group price categories',
          editTitle: 'Edit group price',
          addTitle: 'Add group price',
          fields: {
            mtnSmartPercent: 'Mtn smart percent',
            rightelSmartPercent: 'Rightel smart percent',
            mciSmartPercent: 'Mci smart percent',
            copyGroupPrice: 'Copy Group price',
            isPercentageBenefitForInternational:
              'Is percentage benefit for international?',
            internationalBenefitValuePercent:
              'International benefit value percent',
            internationalBenefitValue: 'International benefit value',
          },
        },
        detailForm: {
          title: 'Detail form',
          legend: 'Detail form',
          editTitle: 'Edit detail form',
          addTitle: 'Add detail form',
        },
      },
      myGroupPriceDetails: {
        title: 'My group price',
      },
      sendSmsFromMap: {
        title: 'Send SMS from the map (update number)',
        title2: 'Send SMS from the map',
        fields: {
          selectCity: 'Select city',
          selectPostalCode: 'Select postal code',
          selectMessageSettings: 'Select message settings',
          regionSettings: 'Region settings',
          detailOfSendingRegions: 'Detail of sending regions',
          Irancell: 'Send to Irancell',
          total: 'Total',
          count: 'Count',
          startFrom: 'Start from',
          simpleCount: 'Simple count',
          simpleStartFrom: 'Simple start from',
          hamrahAval: 'Hamrah aval',
          totalSendCount: 'Total send count',
          acceptAndNext: 'Accept and next',
        },
      },
      baseSendSms: {
        legends: {
          messageInformation: 'Message information',
          sendDateTimeType: 'Send settings',
        },
        fields: {
          receivers: 'Receivers',
          sendDay: 'Send day',
          sendHour: 'Send hour',
          startDay: 'Start day',
          endDay: 'End day',
          startHour: 'Start hour',
          endHour: 'End hour',
          sendDirect: 'Send direct',
          typeSend: 'Type send',
          sendPeriod: 'Send period',
          sendGradual: 'Send gradual',
          periodText: 'Period text',
          everyFewMinutes: 'EveryFewMinutes',
          numberOfSubmissions: 'Number of submissions',
        },
        justSendToWhiteList: 'Just send to white list',
        gradualAlert:
          'The minimum number of recipients should be 1000 numbers.',
        fastSend: 'Fast send',
        sendSms: 'Send SMS',
        editSendSms: 'Edit send SMS',
        warningMessageBeforeClosingEditPage:
          'Warning message before closing edit page',
      },
      sendSMS: {
        title: 'Send SMS',
        editTitle: 'Edit sending SMS',
        fields: {
          receivers: 'Receivers',
        },
        legends: {
          receivers: 'Receivers',
          phonebook: 'Phonebook',
          sendDateTime: 'Send date and time',
        },
        sendSms: 'Send SMS',
        addReceivers: 'Add receivers',
        removeReceivers: 'Remove receivers',
        missive: 'Missive',
      },
      sendSMSWithPhonebook: {
        title: 'Send SMS with phonebook',
        editTitle: 'Edit send SMS with phonebook',
        legends: {
          phonebook: 'Phonebook',
        },
      },
      sendBalkSms: {
        title: 'Bulk send (update number)',
        title2: 'Bulk send',
        editTitle: 'Edit sending bulk SMS',
        titlePostalCode: 'Send zone postal code',
        fields: {
          state: 'State',
          city: 'City',
          region: 'Region',
          businessGroup: 'Business group',
          businessSubGroup: 'Business subgroup',
          sendToRegionDetails: 'Send to region details',
          totalMobileNumber: 'Total mobile number',
          totalSmsSendOnStep: 'Total SMS send on step',
          startFromOnStep: 'Start from on step',
          mobilePrefixOnStep: 'Mobile prefix on step',
          mobileType: 'Mobile type',
          permanentNumber: 'Permanent number',
          creditNumber: 'Credit number',
          id: 'Id',
          operatorType: 'Operator type',
          hamrahAval: 'Hamrah aval',
          irancell: 'Irancell',
          postalCode: 'Postal code',
          zonePostalCode: 'Zone postal codes',
          gender: 'Gender',
          male: 'Male',
          female: 'Female',
          none: 'None',
          calculateTotalCount: 'Calculate total count',
          addToQueries: 'Add to queries',
          selectBalkQueries: 'Select balk queries',
          selectMessageSettings: 'Select message settings',
          senderNumberId: 'Sender number id',
          sendDateTime: 'Send date and time',
          smsBody: 'SMS body',
          smsBodyWithSignature: 'SMS body with signature',
          receivers: 'Receivers',
          sendHour: 'Send hour',
          sendDay: 'Send day',
          startDay: 'Start day',
          endDay: 'End day',
          startHour: 'Start hour',
          endHour: 'End hour',
          sendPeriod: 'Send period',
          sendGradual: 'Send gradual',
          typeSend: 'Type send',
          periodText: 'Period text',
          sendingRegion: 'Sending region',
          asIfStartWith: 'As if start with',
          postalCodeContains: 'Postal Code contains',
          acceptAndNext: 'Accept and next',
          totalCountOfSendingSms: 'Total count of sending SMS',
        },
        errors: {
          emptyRegion: 'Empty region',
          smsCountBiggerThanTotal: 'SMS count bigger than total',
          pleaseEnterValidDateForSend: 'Please enter valid date for send',
          firstSelectWhereToSendSms: 'First select where to send SMS',
          mostSelectAtLeastState: 'Most select at least state',
          mostSelectAtLeastSimType: 'Most select at least sim type',
        },
      },
      campaigns: {
        title: 'Campaigns',
        form: {
          addTitle: 'Add campaign',
        },
      },
      sendQueue: {
        title: 'Organization sending queue',
        usersTitle: 'Users sending queue',
        userTitle: 'User sending queue',
        resellerTitle: 'Reseller sending queue',
        fields: {
          id: 'Id',
          smsText: 'SMS text',
          failureCode: 'Failure code',
          sendType: 'Send type',
          sendSubType: 'Send subtype',
          senderNumber: 'Sender number',
          recipientCount: 'Recipient count',
          mciCount: 'Mci count',
          mtnCount: 'Mtn count',
          rightelCount: 'Rightel count',
          otherCount: 'Other count',
          campaign: 'Campaign',
          sendPrice: 'Total Send price',
          resolutionOfParliamentPrice: 'Resolution of parliament price',
          resolutionPrice: 'Resolution price',
          pageSize: 'Page size',
          pageIndex: 'Page index',
          fromIndex: 'From index',
          zipCode: 'Zip code',
          periodType: 'Period type',
          period: 'Period',
          dateTimeStart: 'Datetime start',
          dateTimeEnd: 'Datetime end',
          dateTimeNext: 'Datetime next',
          dateTimeSend: 'Datetime send',
          smsCount: 'SMS count',
          smsParts: 'SMS parts',
          operatorNumberCount: 'Operator number dount',
          blackListCount: 'Black list count',
          wrongNumberCount: 'Wrong number count',
          socialMediaApplication: 'Social media application',
          socialMediaMessage: 'Social media message',
          isFlashSms: 'Is flash message send?',
          internationalCount: 'International',
          processTextResults: 'Process text results',
          p2PIsSendDuplicateNumber: 'P2p is send duplicate number',
        },
        detail: {
          title: 'SMS sending details',
        },
        receivers: {
          title: 'Receivers',
          toNumber: 'To number',
          deliveryStatus: 'Delivery status',
          sendStatus: 'Send status',
          statusDateTime: 'Status date and time',
          receiversExcel: 'Download excel',
          sendDateTime: 'Send date time',
        },
        sendBulkDetails: {},
      },
      createSmartSmsRequest: {
        title: 'Create smart SMS request',
        legends: {
          requestProperties: 'Request properties',
          publicProperties: 'Public properties',
          requestPublicPlace: 'Request public place',
        },
        errors: {
          forceToEnterDatePeriod: 'For ceto enter date period',
          mustSelectOperator: 'Please select operator',
          titleIsRequired: 'Title is required',
        },
        messages: {
          hint: '',
        },
        dialogs: {
          polygonAtLeaseMostHave3Point: 'Polygon at least most have 3 point',
        },

        horizontalAccordion: {
          workplace: 'Place of work (day stay)',
          home: 'Home (night stay)',
          bankProfile:
            'Bank profile (based on SMS numbers received from banks)',
          jobProfile: 'Job profile',
          travelProfile: 'Travel profile (domestic/foreign)',
          customerClub: 'Customer club',
          profile:
            'Profile of the most incoming/outgoing calls and SMS from one or more specific numbers',
          hobbies: 'Hobbies (sports, shopping, travel, ...)',
        },
        filters: {
          title: 'Filters',
          gender: 'Gender',
          age: 'Age',
          deviceType: 'Device type',
          deviceBrand: 'Device brand',
          eghamatgah: 'Residence',
          gardeshgari: 'Tourism',
          bankProfile: 'Bank profile',
          jobs: 'Job profile',
          favorites: 'Favorites',
          ertebatat: 'Communications on the telecommunications platform',
          artisticCulture: 'Artistic culture',
          artists: 'Artists',
          writers: 'Writers',
          reporters: 'Reporters',
          actors: 'Actors',
          publishers: 'Publisher',
          notImplemented: 'Currently this filter is disabled',
          mobilePrefix: 'Mobile prefix',
        },
        enterPublicPlaceName: 'Name of the selected area',
        publicPlaceName: 'Public Place Name',
        publicPlaceCreated: 'Public Place Created',
        deviceTypes: 'Device type',
        deviceBrands: 'Device brand',
        requestName: 'Request Title',
        ageFrom: 'From age',
        ageTo: 'To age',
        residenceState: 'Place of residence',
        joberState: 'Place of job activity',
        travelerState: 'Send to travelers',
        travelerProvinces: 'Province of origin of the traveler',
        periodicSmartSms: 'Smart Send Campaign',
        isShowGrayListExpireHour: 'Considering duplicate number',
        timingOfRepetitions: 'Timing of repetitions (hours)',
        grayListExpireHour:
          'For how many hours, a duplicate number will be considered?',
        smartRequestType: 'Smart send request type',
        club: 'Customer club',
        operationType: 'Type of operation',
        cellList: 'Cell list',
        mobilePrefix: 'Mobile prefix',
        deviceModels: 'Device models',
      },
      confirmSmartSmsRequest: {
        title: 'Send Smart SMS',
        legends: {
          smsPart: 'SMS Settings',
          requestData: 'Recipients Details',
          requestPublicPlace: 'Place to send',
          publicMap: 'Selected area',
          yourCampaignFrom: 'Your campaign from date',
          untilDate: 'Until date',
          period: 'Period',
          runAnd: 'Run and',
          person: 'Person',
          ofTheTargetNumbersWillReceiveSMS:
            'They receive SMS from the desired numbers',
          every: 'Every',
        },
        errors: {
          couldNotEditRequest:
            'Your request is not in a state where you can confirm or reject its information.',
          pleaseWaitUntilTheRequestStateChanged:
            'Please wait until the status of the request changes.',
          mustSelectOperator: 'Please select an operator.',
        },
        dialogs: {},
        fields: {
          sendDay: 'Send date',
          sendHour: 'Send hour',
          sentDelayType: 'Send type',
          sentDelayValue: 'Time after receiving',
          percentageToSend: 'Send percentage',
          countToSend: 'Number of Sends',
          sendCountType: 'Send count calculation type',
          percentage: 'Percentage',
          count: 'Number',
          maxSendCount: 'Maximum number of smart campaign sends',
          maxDailySendCount: 'Maximum daily send count',
          socialMediaApplicationName: 'Social media application name',
          socialMediaFileTitle: 'Social media file title',
        },
        filter: {
          yourMessageSendTo:
            'Your message will be sent to people with the following characteristics in the selected ranges:',
          sent: 'Will be sent in selected ranges',
        },
        periodTypeValue: 'Time unit',
        periodText: 'Repeat every :',
        UsePercentage: 'Use percentage',
        count: 'Amount',
        createCampain: 'Create and run a campaign',
        editCampaign: 'Edit campaign',
      },
      smsTemplate: {
        title: 'SMS template',
        form: {
          addTitle: 'Add SMS template',
          editTitle: 'Edit SMS template',
        },
      },
      smsTemplateGroup: {
        title: 'SMS template group',
        form: {
          editTitle: 'Edit SMS template group',
          addTitle: 'Add SMS template group',
        },
      },
      accountInformation: {
        title: 'Bank account numbers',
        form: {
          editTitle: 'Edit bank account number',
          addTitle: 'Add bank account number',
          legend: 'Bank account numbers',
          fields: {
            accountNo: 'Account no',
            branch: 'Branch',
            cardNo: 'Card no',
            iban: 'Iban',
            owner: 'Owner',
          },
        },
      },
      bankOnlineGateways: {
        title: 'Bank online gateways',
        form: {
          bankOnlineGatewaysForm: 'Bank online gateways informations',
          editTitle: 'Edit bank online gateway',
          addTitle: 'Add bank online gateway',
          fields: {
            accountInformationId: 'Account Information id',
            accountInformationOwner: 'Account information owner',
            typeIPG: 'Type ipg',
            configJson: 'Config json',
            isGeneralUse: 'Is general use',
            isFactorUse: 'Is factor use',
          },
        },
      },
      zones: {
        title: 'Zones',
        form: {
          editTitle: 'Edit zone',
          addTitle: 'Add zone',
          legends: {
            generalSettings: 'General settings',
            mapSetting: 'Map setting',
          },
        },
        newCountry: 'New country',
        newState: 'New state',
        newCity: 'New city',
        newArea: 'New area',
        editCountry: 'Edit country',
        editState: 'Edit state',
        editCity: 'Edit city',
      },
      roles: {
        title: 'Roles',
        cloneRole: 'Clone Role',
        form: {
          editTitle: 'Edit role',
          addTitle: 'Add role',
          cloneTitle: 'Clone role',
          legend: 'Roles',
          editRoleConfirmation: {
            inRole: 'In role ',
            theFollowingChangesWillBeApplied:
              'The following changes will be applied',
            accessIsRemoved: 'Access is removed',
            theOrganizationIsDeleted: 'The organization is deleted',
            listOfOrganizationsToBeDeleted:
              'List of organizations to be deleted',
            description1:
              'By removing these items, it will be applied to all related sub-Groups and stored data',
            enterTheNumberBelowToConfirmTheChanges:
              'Enter the number below to confirm the changes',
          },
        },
        userRoles: {
          title: 'User roles',
        },
      },
      roleTemplates: {
        title: 'Role templates',
        form: {
          editTitle: 'Edit role template',
          addTitle: 'Add role template',
          legend: 'Role templates',
          secondStep: {
            title:
              'If you activate the button below, the roles created for this role format will change',
            isChangeRoles: 'Do the roles change?',
          },
        },
        organizationRoles: {
          title: 'Assignment of role templates to organizations',
        },
      },
      guilds: {
        title: 'Guilds',
        form: {
          editTitle: 'Edit guild',
          addTitle: 'Add guild',
          legend: 'Guilds',
        },
      },
      kibanaDashboards: {
        title: 'Kibana dashboards',
        form: {
          editTitle: 'Edit dashboard',
          addTitle: 'Add dashboard',
          legend: 'Dashboard information',
        },
      },
      refundDeliveryStatus: {
        title: 'Refund delivery status',
        form: {
          editTitle: 'Edit refund delivery status',
          addTitle: 'Add refund delivery status',
          legend: 'Refund delivery status information',
          fields: {
            deliveryStatuses: 'Delivery status ',
          },
        },
      },
      resellers: {
        title: 'Resellers',
        form: {
          editTitle: 'Edit reseller',
          addTitle: 'Add reseller',
          legend: 'Reseller Informations',
          fields: {
            reseller: 'Reseller',
            pricePerSms: 'Price per SMS',
            panelPercent: 'Panel percent',
            target: 'Target',
          },
        },
        resellers: {
          title: 'Resellers',
        },
        resellerOrganizations: {
          title: 'Reseller organizations',
        },
      },
      resellersTarget: {
        title: 'Resellers target',
        form: {
          editTitle: 'Edit resellers target',
          addTitle: 'Add resellers target',
          legend: 'Resellers target',
          fields: {
            times: 'Times',
            targetValue: 'Target value',
            credit: 'Credit',
          },
        },
      },
      systemSetting: {
        title: 'System setting',
        form: {
          editTitle: 'Edit system setting',
          addTitle: 'Add system setting',
          legend: 'System setting',
          description:
            'You can set the settings for different parts of your panel in this form',
        },
      },
      panelSetting: {
        title: 'Panel setting',
        form: {
          editTitle: 'Edit panel setting',
          addTitle: 'Add panel setting',
          legend: 'Setting',
          description:
            'You can set the settings for different parts of your panel in this form',
        },
      },
      creditNotification: {
        title: 'Credit notification',
        form: {
          editTitle: 'Edit user credit',
          addTitle: 'Add user credit',
          legend: 'Credit notification',
          fields: {
            lastSendDateTime: 'Last send date and time',
            isSend: 'Is send',
            scheduledMessageId: 'Scheduled message id',
          },
        },
      },
      otp: {
        title: 'Authentication SMS format',
        form: {
          editTitle: 'Edit authentication SMS',
          addTitle: 'Add authentication SMS',
          changeStatusTitle: 'Change status title',
          code: '123',
          name: 'Ali',
          code2: 'Code {0}',
          name2: 'Dear {1} ,',
          description: 'Welcome to SmsPanel',
          code3: 'Code 123',
          name3: 'Dear Ali ,',
          legends: {
            specifications: 'SMS format',
            help: 'Help',
          },
          messages: {
            description1:
              'Enter the variable parameters in the message text as {#}',
            description2:
              'The # type in the above case is numeric and starts from 0 and increases in order {0}, {1}, {2},...',
            description3:
              'When sending an authentication message, the number of variable parameters defined in the message must be sent',
            description4: 'To send { یا } in SMS format, use {{ یا }}',
            sampleOtp: 'Sample Otp',
            sampleParameters: 'Example of sent parameters for the SMS above',
            finalMessage: 'SMS sent to the user',
          },
          fields: {
            priority: 'Priority',
            smsText: 'SMS Text',
            lastModified: 'Last Modified',
            OtpStatus: 'Otp Status',
          },
        },
      },
      menus: {
        name: 'Name',
        title: 'Menus',
        form: {
          editTitle: 'Edit menu',
          addTitle: 'Add menu',
          legends: {
            generalMenu: 'General menu',
            helpMenu: 'Help menu',
          },
          fields: {
            route: 'Route',
            order: 'Order',
            claim: 'Claim',
            class: 'Class',
            claims: 'Claims',
            helpText: 'Help text',
            imageHelp: 'Image help',
            videoHelp: 'Video help',
            pdfHelp: 'Pdf help',
            fileHelp: 'File help',
          },
        },
        uploadFileForm: {
          editTitle: 'Edit guide',
          addTitle: 'Add guide',
          legend: 'Upload file form',
          fields: {
            helpFileType: 'Help file type',
            file: 'File',
          },
        },
      },
      help: {
        title: 'Help',
        helpDetail: 'Help detail',
      },
      organizationTransactions: {
        title: 'Organization transactions',
        resellerTransactionTitle: 'Reseller transaction title',
        outboxTransactionsTitle: 'Outbox transactions title',
        transactionsDetailTitle: 'Transaction detail title',
        resellerTransactionsDetailTitle: 'Reseller transactions detail title',
        transactionsExcel: 'Download transactions excel file',
        resellerTransactionsExcel: 'Download reseller transactions excel file',
        form: {
          editTitle: 'Edit title',
          addTitle: 'Add title',
          fields: {
            packageId: 'Package id',
            packageTitle: 'Package title',
            outboxId: 'Outbox id',
            paymentId: 'Payment id',
            isIncrement: 'Is increment',
            typeTransaction: 'Type transaction',
            typeCreditChange: 'Type credit change',
            currentCredit: 'Current credit',
          },
          legend: 'Transaction informations',
        },
      },
      sendLimits: {
        title: 'Send limits',
        form: {
          editTitle: 'Edit limit',
          addTitle: 'Add limit',
          legend: 'Limit informations',
          fields: {
            privateNumberNumber: 'Number',
            dailySendLimit: 'Daily send limit',
            monthlySendLimit: 'Monthly send limit',
          },
        },
      },
      allPrivateNumberSendLimit: {
        title: 'Users list numbers',
        form: {
          fields: {
            sendTypesList: 'Send Types List ',
            privateNumber: 'Private number ',
            canSeeReceivedSms: 'Can see received sms',
          },
        },
      },
      automaticResend: {
        title: 'Automatic resend',
        form: {
          editTitle: 'Edit automatic resend',
          addTitle: 'Add automatic resend',
          fields: {
            privateNumber: 'Private number',
            deliveryStatus: 'Delivery status',
            targetPrivateNumbers: 'Target private numbers',
          },
          legend: 'Automatic resend',
        },
      },
      payments: {
        title: 'Payments',
        resellerTitle: 'List of seller payments',
        detail: 'Detail',
        confirmPayment: 'Confirm payment',
        rejectPayment: 'Reject payment',
        paymentsExcel: 'Download payments excel',
        fields: {
          accountInformationId: 'Account Information id',
          accountInformationOwner: 'Account information owner',
          accountInformationAccountNo: 'Account information account no',
          accountInformationCardNo: 'Account information cardNo',
          accountInformationBank: 'Account information bank',
          paymentDate: 'Payment date',
          typePayment: 'Type payment',
          typeStatus: 'Type status',
          billNumber: 'Bill number',
          isOnlineGeneral: 'Is online general',
          createdBy: 'Created by',
          orderId: 'Order id',
          adminResellerCode: 'Admin reseller code',
          resellerCode: 'Reseller code',
          userFirstLastName: 'User first last name',
          chequeImageAddress: 'Cheque image address',
          receiverOrganizationName: 'Receiving organization',
          userName: 'Paying user',
          payerOrganizationName: 'Paying organization',
          isHaveImage: 'Is have image',
          smsCountPerPriceDescription: 'sms count per price description',
          smsCount: 'Sms count',
          resolutionOfParliament: 'Resolution of parliament',
          groupPriceDetailPrice: 'Group price detail price',
        },
      },
      paymentsForConfirm: {
        title: 'Payments for confirm',
        resellerTitle: 'List of payments for seller approval',
        confirmPayment: 'Confirm payment',
        rejectPayment: 'Reject payment',
      },
      newPayment: {
        title: 'Increase credit',
        legend: 'New payment',
        publicPaymentGateway: 'Choose public payment',
        fields: {
          accountInformationId: 'Account Information id',
          billNumber: 'Bill number',
          branchCode: 'Branch code',
          chequeAccountNumber: 'Cheque account number',
          chequeImage: 'Cheque image',
          chequeAmount: 'Cheque amount',
          chequeImageAddress: 'Cheque image address',
          dueDate: 'Due date',
          holderName: 'Holder name',
          isOnlineGeneral: 'Is online general',
          serialNumber: 'Serial number',
          sayadNumber: 'Sayad number',
          seriesNumber: 'Series number',
          nationalCode: 'National code',
          orderId: 'Order id',
          referenceId: 'Reference id',
          typePayment: 'Type payment',
          paymentDate: 'Payment date',
          paymentTime: 'Payment hours',
        },
        invoice: {
          title: 'Invoice',
        },
      },
      chequePayments: {
        title: 'Cheques list',
        resellerTitle: 'Sellers check list',
        detail: 'Detail',
        fields: {
          branchCode: 'Branch code',
          chequeAccountNumber: 'Cheque account number',
          chequeAmount: 'Cheque amount',
          chequeImageAddress: 'Cheque image address',
          dueDate: 'Due date',
          holderName: 'Holder name',
          isPassed: 'Is passed',
          nationalCode: 'National code',
          paymentId: 'Payment id',
          sayadNumber: 'Sayad number',
          serialNumber: 'Serial number',
          seriesNumber: 'Series number',
          typeBank: 'Type bank',
          payerOrganizationName: 'Paying organization',
          receiverOrganizationName: 'Receiving organization',
        },
      },
      informations: {
        name: 'Informations',
        title: 'Informations',
        form: {
          addTitle: 'Add information',
          editTitle: 'Edit information',
          fields: {
            id: 'Id',
            displayForAllSubOrganizations: 'Display for all sub organizations',
            customerDomainName: 'Customer domain name',
            startDate: 'Start date',
            endDate: 'End date',
            isRequiredToSeen: 'Is required to seen',
          },
          legend: 'Informations',
        },
      },
      panelDocumentations: {
        title: 'Panel Documentations',
        webServiceSendHelp: 'Help for sending with web service',
        downloadDocumentations: 'Download documentations',
        smartDocumentations: 'Smart send documentations',
      },
      audits: {
        title: 'Audits',
        auditList: 'Audits list',
        auditDetail: 'Audits details',
        fields: {
          referenceId: 'ReferenceId',
          remoteIpAddress: 'Remote ip address',
          localIpAddress: 'Local ip address',
          osInfo: 'Os info',
          browserName: 'Browser name',
          operationType: 'Operation type',
          operationCount: 'Number of operations',
          old: 'Old',
          new: 'New',
          comments: 'Comments',
          timezone: 'Timezone',
          ip: 'Ip',
          applicationName: 'Application name',
          lat: 'Lat',
          lon: 'Lon',
          country_iso_code: 'Country iso code',
          country_name: 'Country name',
          continent_code: 'Continent code',
          userAgent: 'User agent',
          className: 'Class name',
          os: {
            full: 'Os full name',
            version: 'Os version',
            name: 'Os name',
          },
          device: {
            name: 'Device name',
          },
          clientUserAgent: {
            name: 'Client user agent name',
            version: 'Client user agent version',
          },
        },
      },
      superAdminAudits: {
        title: 'Super admin audits',
        legends: {
          environmentInfo: 'Environment info',
          document: 'Audit informations',
        },
        fields: {
          startDate: 'Start date',
          endDate: 'End date',
          logCode: 'Log code',
          logText: 'Log text',
          logLocation: 'Log location',
          userInfo: {
            userAgent: 'User agent',
            applicationName: 'Application name',
            remoteIpAddress: 'Remote ip address',
            userId: 'User id',
            localIpAddress: 'Local ip address',
            userName: 'Username',
            remoteIpAddressGeo: {
              geo: {
                timezone: 'Timezone',
                continent_code: 'Continent code',
                country_name: 'Country name',
                country_iso_code: 'Country iso code',
                location: {
                  lat: 'Lat',
                  lon: 'Lon',
                },
              },
              ip: 'Ip',
            },
            clientUserAgent: {
              name: 'Client user agent name',
              version: 'Client user agent version',
              os: {
                full: 'Os full name',
                version: 'Os version',
                name: 'Os name',
              },
              device: {
                name: 'Device name',
              },
            },
          },
          environment: {
            userName: 'Environment username',
            machineName: 'Machine name',
            domainName: 'Domain name',
            culture: 'Culture',
          },
        },
      },
      apiAudits: {
        title: 'Api audits',
        legends: {
          environmentInfo: 'Environment info',
          userInfo: 'User info',
          document: 'Document',
        },
        fields: {
          startDate: 'Start date',
          endDate: 'End date',
          logCode: 'Log code',
          logText: 'Log text',
          logLocation: 'Log location',
          userId: 'User id',
          organizationId: 'Organization id',
          token: 'Token',
          tokenIp: 'Token ip',
          tokenId: 'Token id',
          requestMethod: 'Request method',
          requestPath: 'Request path',
          scheduledMessageId: 'Scheduled message id',
          status: 'Status',
          requestBody: 'Request body',
          userInfo: {
            userAgent: 'User agent',
            applicationName: 'Application name',
            remoteIpAddress: 'Remote ip address',
            userId: 'User id',
            localIpAddress: 'Local ip address',
            userName: 'Username',
            remoteIpAddressGeo: {
              geo: {
                timezone: 'Geo timezone',
                continent_code: 'Continent code',
                country_name: 'Country name',
                country_iso_code: 'Country iso code',
                location: {
                  lat: 'Lat',
                  lon: 'Lon',
                },
              },
              ip: 'Ip',
            },
            clientUserAgent: {
              name: 'Client user agent name',
              version: 'Client user agent version',
              os: {
                full: 'Os full name',
                version: 'Os version',
                name: 'Os name',
              },
              device: {
                name: 'Device name',
              },
            },
          },
          environment: {
            userName: 'Environment Username',
            machineName: 'Environment machine name',
            domainName: 'Environment domain name',
            culture: 'Environment culture',
          },
        },
      },
      loginAudits: {
        title: 'Api audits',
        legends: {
          environmentInfo: 'Environment info',
          userInfo: 'User info',
          document: 'Document',
        },
        fields: {
          logDateTime: 'Log date time',
          startDate: 'Start date',
          endDate: 'End date',
          logCode: 'Log code',
          logText: 'Log text',
          logLocation: 'Log location',
          userId: 'User id',
          organizationId: 'Organization id',
          token: 'Token',
          tokenIp: 'Token ip',
          tokenId: 'Token id',
          requestMethod: 'Request method',
          requestPath: 'Request path',
          scheduledMessageId: 'Scheduled message id',
          status: 'Status',
          requestBody: 'Request body',
          userInfo: {
            userAgent: 'User agent',
            applicationName: 'Application name',
            remoteIpAddress: 'Remote ip address',
            userId: 'User id',
            localIpAddress: 'Local ip address',
            userName: 'Username',
            remoteIpAddressGeo: {
              geo: {
                timezone: 'Geo timezone',
                continent_code: 'Continent code',
                country_name: 'Country name',
                country_iso_code: 'Country iso code',
                location: {
                  lat: 'Lat',
                  lon: 'Lon',
                },
              },
              ip: 'Ip',
            },
            clientUserAgent: {
              name: 'Client user agent name',
              version: 'Client user agent version',
              os: {
                full: 'Os full name',
                version: 'Os version',
                name: 'Os name',
              },
              device: {
                name: 'Device name',
              },
            },
          },
          environment: {
            userName: 'Environment Username',
            machineName: 'Environment machine name',
            domainName: 'Environment domain name',
            culture: 'Environment culture',
          },
        },
      },
      rulesAudits: {
        title: 'Token rules audits',
        legends: {},
        fields: {
          startDate: 'Start date',
          endDate: 'End date',
          logCode: 'Log code',
          logText: 'Log text',
          requestMethod: 'Request method',
          requestPath: 'Request path',
          requestToken: 'Request token',
          status: 'Status',
          userInfo: {
            userAgent: 'User agent',
            applicationName: 'Application name',
            remoteIpAddress: 'Remote ip address',
            userId: 'User id',
            localIpAddress: 'Local ip address',
            userName: 'Username',
            remoteIpAddressGeo: {
              geo: {
                timezone: 'Timezone',
                continent_code: 'Continent code',
                country_name: 'Country name',
                country_iso_code: 'Country iso code',
                location: {
                  lat: 'Lat',
                  lon: 'Lon',
                },
              },
              ip: 'Ip',
            },
            clientUserAgent: {
              name: 'Client user agent name',
              version: 'Client user agent version',
              os: {
                full: 'Os full name',
                version: 'Os version',
                name: 'Os name',
              },
              device: {
                name: 'Device name',
              },
            },
          },
          environment: {
            userName: 'Environment Username',
            machineName: 'Environment machine name',
            domainName: 'Environment domain name',
            culture: 'Environment culture',
          },
        },
      },
      systemNumbers: {
        title: 'System numbers',
        legend: 'System numbers',
        fields: {
          number: 'Number',
          numberType: 'Number type',
          organizationName: 'Organization name',
        },
      },
      webhook: {
        title: 'Webhook',
        form: {
          editTitle: 'Edit webhook',
          addTitle: 'Add webhook',
          legend: 'Webhook',
          sender: 'Sender number',
          privateNumber: 'Private number',
          message: 'Message body',
          encoding: 'Encoding',
          messageId: 'Message Id',
          status: 'Message status',
          sampleCode: 'Sample code',
          receivedDate: 'Received date',
          fields: {
            url: 'Url',
            tryCount: 'Try count',
            webhookType: 'Webhook type',
          },
          legends: {
            specifications: 'Specifications',
            address: 'Webhook address',
          },
          messages: {
            description1: 'Refer to the manual for detailed parameters.',
            description3: 'The address must start with http or https.',
            description2:
              'Validation of the entered address is the responsibility of the user.',
            description4: 'Status webhook will send only for web service sends',
          },
        },
      },
      apiToken: {
        title: 'Api token',
        ipRules: 'Ip rules',
        createIpRules: 'Create ip rules',
        clientRules: 'Client rules',
        safeIps: 'Safe ips',
        form: {
          editTitle: 'Edit api token',
          addTitle: 'Add api token',
          changeStatusTitle: 'Api token change status',
          legend: 'Api token',
          fields: {
            ip: 'Ip',
            token: 'Token',
            status: 'Status',
            isCanSend: 'Is can send',
            isCanSendSmart: 'Is can send smart',
            isIgnoreCheckIp: 'Is ignore check ip?',
          },
        },
      },
      ipRules: {
        title: 'Ip rules',
        allIpRules: 'All ip rules',
        form: {
          addTitle: 'Create ip rule',
          editTitle: 'Edit ip rule',
          legend: 'Rule details',
          fields: {
            ip: 'Ip',
            limit: 'Limit',
            period: 'Period',
            periodType: 'Period type',
            endpoint: 'End point',
            apiTokenId: 'Api token id',
            ipRulesFromWebService: 'Ip rules from web service',
            ipRulesFromTable: 'Ip rules from table',
          },
        },
      },
      clientRules: {
        title: 'Client rules',
        form: {
          addTitle: 'Create client rule',
          editTitle: 'Edit client rule',
          legend: 'Rule details',
          fields: {
            ip: 'Ip',
            limit: 'Limit',
            period: 'Period',
            endpoint: 'End point',
            apiTokenId: 'Api token id',
            clientId: 'Client id',
            clientRulesFromWebService: 'ClientRulesFromWebService',
            clientRulesFromTable: 'ClientRulesFromTable',
          },
        },
      },
      pollParsersInboxes: {
        title: 'Poll parser inboxes',
        inboxesExcel: 'Download excel file',
      },
      modules: {
        title: 'Modules',
        modules: {
          title: 'Modules',
        },
        modulesOrganizations: {
          title: 'Modules organizations',
          form: {
            editTitle: 'Edit modules organization',
            addTitle: 'Add modules organization',
            legend: 'Modules organizations',
            fields: {
              moduleId: 'Module id',
              organizationId: 'Organization id',
            },
          },
        },
      },
      filterWords: {
        title: 'Filtered words',
        form: {
          editTitle: 'Edit filtered word',
          addTitle: 'Add filtered word',
          fields: {
            userFirstName: 'User first name',
            userLastName: 'User last name',
          },
        },
      },
      organizationsBlackListExceptions: {
        title: 'Organizations black list exceptions',
        form: {
          addTitle: 'Add exceptions',
        },
      },
      phonebook: {
        title: 'Phonebook',
        form: {
          addTitle: 'Add phonebook',
          editTitle: 'Edit phonebook',
          fields: {
            title: 'Title',
            isPublic: 'Is public',
            isShowNumber: 'Is show number',
            contactsCount: 'Contacts count',
            whiteMessageId: 'Customers club id',
            deviceConnectionPort: 'Customer club device port',
            isSendMessageAfterAddFromDevice:
              'Is send message after add from device',
          },
          legends: {
            phonebookInformation: 'Phonebook information',
          },
        },
        customFieldsForm: {
          title: 'Custom fields form',
          searchInCustomFields: 'Search in custom fields',
        },
      },
      contacts: {
        title: 'Contacts',
        deleteContactsFormPhonebooks: {
          title: 'Remove contact from groups',
          message: 'Select the groups you want to remove contacts from',
          selectCurrentGroup: 'Select the current group',
        },
        addBtns: {
          addSingle: 'Add single',
          addListNumber: 'Add list number',
          addFromFile: 'Add from excel file',
        },
        form: {
          addTitle: 'Add contact',
          editTitle: 'Edit contact',
          fields: {
            job: 'Job',
            birthdate: 'Birth date',
            telephone: 'Telephone',
            cellphone: 'Cell phone',
            phonebookGroup: 'Phonebook group',
            createType: 'Create type',
          },
          legends: {
            contactInfo: 'Contact info',
            customFields: 'Custom fields',
          },
        },
        importfromfile: {
          title: 'Import from file',
          legends: {
            importFromFile: 'Import From File',
            previewFile: 'Preview File',
          },
          fields: {
            selectfile: 'Select file',
            firstNameFieldName: 'First name field name',
            lastNameFieldName: 'Last name field name',
            emailFieldName: 'Email field name',
            birthDateFieldName: 'Birth date field name',
            telephoneFieldName: 'Telephone field name',
            jobFieldName: 'Job field name',
            addressFieldName: 'Address field name',
            empty: 'Empty',
            cellPhone: 'Cellphone',
          },
        },
      },
      dynamicTemplate: {
        title: 'Dynamic template',
        form: {
          addTitle: 'Add dynamic template',
          editTitle: 'Edit dynamic template',
          fields: {
            customText: 'Custom text',
            format: 'Format',
          },
          messages: {
            description1:
              'To add fixed fields, click on the field name in the list above',
            description2:
              'You can also add desired text and field from the profile section.',
            note1:
              'Pay attention to the following points when designing a dynamic template :',
            note2:
              'If a desired field or a fixed field is defined in a dynamic format and a value is not registered for it in the contact, its text will be sent empty in the SMS.',
            note3:
              'If a desired field is defined in a dynamic format that does not exist in the contact group (phonebook), its text will be sent empty in the SMS.',
          },
        },
      },
      outboxMessages: {
        title: 'Outbox messages',
        usersTitle: 'Users outbox message',
        userTitle: 'User outbox message',
        resellerTitle: 'Reseller outbox message',
        resellersTitle: 'Resellers outbox message',
        usersOutboxMessages: 'Users outbox messages',
        userOutboxMessages: 'User outbox messages',
        editStatusTitle: 'Edit outbox message status',
        getNewDeliveryStatusTitle: 'Request the latest delivery status',
        outboxExcel: 'Outbox excel',
        advancedSearch: {
          title: 'Advanced Search',
          zipCode: 'Postal code',
          phonebookIds: 'Phonebook group',
          toNumber: 'Receiver',
          guild: 'Guild',
          zone: 'Zone',
          startDate: 'Start Date',
          endDate: 'End Date',
          description: 'Description',
          smsText: 'Sms text',
          sendStartDate: 'Send start date',
          sendEndDate: 'Send end date',
          sendStartHour: 'Send start hour',
          sendEndHour: 'Send end hour',
          sendStatus: 'Send status',
          deliveryStatus: 'Delivery status',
        },
        resendDetail: {
          title: 'Resend Detail',
          createdBy: 'Created By',
          scheduledMessageId: 'Previous ID',
          newScheduledMessageId: 'Current ID',
          deliveryStatuses: 'Delivery Status',
        },
        fields: {
          countSendBlackList: 'Count send blacklist',
          blackListCount: 'Blacklist Count',
          countResendOther: 'Count resend other',
          cpType: 'Cp type',
          exportDataStatus: 'Export data status',
          receiverCount: 'Receiver count',
          organizationId: 'Organization id',
          scheduledMessageId: 'Scheduled message id',
          sendingTryCount: 'Sending try count',
          campaign: 'Campaign',
          mciCount: 'Mci',
          mtnCount: 'Mtn',
          otherCount: 'Other',
          rightelCount: 'Rightel',
          smsEncoding: 'SMS encoding',
          smsParts: 'SMS parts',
          smsText: 'SMS text',
          status: 'Status',
          contactsCount: 'Contacts count',
          resellerName: 'Reseller Name',
          sendSubType: 'Send SubType',
          sendType: 'SendType',
          isResend: 'Is Resend',
          senderNumber: 'Sender Number',
          isWhiteMessage: 'Is white message?',
          isFlashSms: 'Is flash message?',
          period: 'period',
          processTextResults: 'Process text results',
          p2PIsSendDuplicateNumber: 'P2p is send duplicate number',
        },
        detail: {
          title: 'SMS sending Details',
          PhonebookRecipientTitle: 'Sending with phonebook details',
        },
        resendByDeliveryStatus: {
          title: 'Resend by delivery status',
          statues: 'Statues',
          isSendFromMyPanel: 'Is Sent From My Panel',
          extraReceivers: 'Extra receivers',
          selectDeliveryStatus: 'Select delivery status',
          messageInformation: 'Message information',
          receiversAndSendDateTime: 'Receivers and send date and time',
          deliveryStatusRequiredMsg: 'Delivery status required msg',
          sendDirect: 'Send direct',
          sendGradual: 'Send gradual',
          isFlashSms: 'Is flash sms',
        },
      },
      dynamicSendSms: {
        title: 'Dynamic send SMS',
        form: {
          addTitle: 'Add dynamic send SMS',
          editTitle: 'Edit dynamic send SMS',
          fields: {
            customText: 'Custom text',
            format: 'Format',
            dynamicTemplates: 'Dynamic templates',
          },
        },
        messages: {
          warningMessageBeforeClosingEditPage:
            'Warning message before closing edit page',
          note1: 'Pay attention to the following points in dynamic sending :',
          note2:
            'If a desired field or a fixed field is defined in a dynamic format and a value is not registered for it in the contact, its text will be sent empty in the SMS.',
          note3:
            'If a desired field is defined in a dynamic format that does not exist in the contact group (phone book), its text will be sent empty in the SMS.',
        },
        legends: {
          messageInformation: 'Message information',
          phonebook: 'Phonebook',
        },
      },
      sendP2pSms: {
        title: 'Send p2p SMS',
        trackingNumberTitle: 'Send p2p with tracking number SMS',
        editTitle: 'Edit send p2p SMS',
        legends: {
          selectFile: 'Select file',
          smsTextSetting: 'SMS text setting',
          smsSetting: 'SMS setting',
        },
        fields: {
          toNumberFieldName: 'To number field name',
          trackingNumberFieldName: 'Tracking number field name',
        },
        messages: {
          description1:
            'To set the SMS text, you can select the desired column by clicking from the list of columns.',
          description2:
            'Also, to move the columns in the blue box, grab and move the column.',
          description3:
            'It should be noted that in order to add the desired text, you can type your desired text in the desired text field and press the add key',
          description4: 'Add your text to the SMS.',
          sendWithDuplicateNumbersMsg:
            'Warning: Selecting this option will not delete duplicate numbers in the selected Excel file. Before using this option, make sure that you are going to send different text for fixed recipients.',
        },
      },
      sendP2pSmartSms: {
        title: 'Send P2P smart sms',
        editTitle: 'Edit send P2P smart sms',
        legends: {
          selectFile: 'Select file',
          smsTextSetting: 'SMS text setting',
          smsSetting: 'SMS setting',
          publicMap: 'Public map',
        },
        fields: {
          toNumberFieldName: 'To number field name',
        },
        messages: {
          description1:
            'To set the SMS text, you can select the desired column by clicking from the list of columns.',
          description2:
            'Also, to move the columns in the blue box, grab and move the column.',
          description3:
            'It should be noted that in order to add the desired text, you can type your desired text in the desired text field and press the add key',
          description4: 'Add your text to the SMS.',
          sendWithDuplicateNumbersMsg:
            'Warning: Selecting this option will not delete duplicate numbers in the selected Excel file. Before using this option, make sure that you are going to send different text for fixed recipients.',
        },
        errors: {
          couldNotEditRequest: 'Could not edit request',
          pleaseWaitUntilTheRequestStateChanged:
            'Please wait until the request state changed',
          mustSelectOperator: 'Please select operator',
        },
      },
      sendSmartSMS: {
        title: 'Send smart SMS',
        detail: 'Details',
        smartSmsDetailExcel: 'Smart sms detail excel',
        smartSmsDetailTableExcel: 'Smart sms detail table excel',
        form: {
          addTitle: 'Add send smart SMS',
          editTitle: 'Edit send smart SMS',
          legend: 'Send smart SMS',
          fields: {
            status: 'Status',
            statusDatetime: 'Status date and time',
            startDatetime: 'Start date and time',
            endDatetime: 'End date and time',
            title: 'Send smart SMS field',
            responseData: 'Response data',
          },
        },
      },
      smartSmsRequests: {
        title: 'Smart SMS requests',
        detail: 'Detail',
        smartSmsRequestExcel: 'Download smart sms request excel',
        form: {
          addTitle: 'Add smart SMS request',
          editTitle: 'Edit smart SMS request',
          legend: 'Smart SMS request',
          fields: {
            status: 'Status',
            statusDatetime: 'Status date and time',
            startDatetime: 'Start date and time',
            endDatetime: 'End date and time',
            title: 'Smart SMS request field',
            responseData: 'Response data',
          },
        },
      },
      resellerSmartSmsRequests: {
        title: 'Reseller smart SMS requests',
        form: {
          fields: {
            status: 'Status',
            statusDatetime: 'Status date and time',
            startDatetime: 'Start date and time',
            endDatetime: 'End date and time',
          },
        },
      },
      fastSendSmsPatternByPhonebook: {
        title: 'Fast send SMS pattern by phonebook',
      },
      pollParsers: {
        surveyTitle: 'Survey title',
        competitionTitle: 'Competition title',
        options: 'Options',
        selectOption: 'Select option',
        form: {
          pollAddTitle: 'Add survey',
          pollEditTitle: 'Edit survey',
          competitionAddTitle: 'Add competition',
          competitionEditTitle: 'Edit competition',
          legends: {
            surveySpecifications: 'Survey specifications',
            surveyResponse: 'Survey response',
            surveyMatchOptions: 'Survey match options',
            competitionSpecifications: 'Competition specifications',
            competitionResponse: 'Competition response',
            competitionMatchOptions: 'Competition match options',
          },
          fields: {
            privateNumberId: 'Private number id',
            senderPhonebookId: 'Sender phonebook id',
            optionTitle: 'Option title',
            keyword: 'Keyword',
            phonebookName: 'Save in phonebook',
            isCorrect: 'Is correct',
            isJustTrueAnswer: '',
            isMainQuestion: 'Is main question?',
          },
          messages: {
            emptyOption: 'Empty option',
            onlyOneCorrectOption: 'Only one correct option',
            optionTitleRequired: 'Enter the title of the option',
            keywordRequired: 'Enter the keyword',
            uniqueTitle: 'The title of the option cannot be repeated',
            uniquekeyword: 'The keyword cannot be repeated',
          },
        },
        stats: {
          title: 'Statistics',
          correctAnswerCount: 'Correct Answer Count',
          incorrectAnswerCount: 'Incorrect Answer Count',
          surveyStats: 'Survey statistics',
          competitionStats: 'Competition statistics',
          doughnutChartTitle: 'Chart of selected options',
          pieChartTitle: 'Chart of the number of correct and incorrect choices',
        },
      },
      textParsers: {
        title: 'Text parsers',
        form: {
          addTitle: 'Add text parser',
          editTitle: 'Edit text parser',
          fields: {
            isChildrenChange: 'Is Children change',
            title: 'Fields',
            privateNumberId: 'Private number id',
            senderConditionType: 'Sender condition type',
            senderConditionValue: 'Sender condition value',
            senderPhonebookId: 'Sender phonebook id',
            ifConditionType: 'If condition type',
            ifConditionValue: 'If condition value',
            thenConditionType: 'Then condition type',
            thenConditionValue: 'Then condition value',
            senderNumber: 'Sender number',
            mobileNumber: 'Mobile number',
            email: 'Email',
            matchingDynamicTemplateId: 'Match ing dynamic template id',
            noMatchingDynamicTemplateId: 'No match ing dynamic template id',
            ipAndPort: 'Ip and port',
            sentDelayType: 'Send type',
            sentDelayValue: 'Once per {{type}}',
          },
          legends: {
            filterConditions: 'Filter conditions',
            generalInformation: 'General information',
            senderNumber: 'Sender number',
          },
        },
      },
      safeIps: {
        safeIpsTitle: 'Safe ips',
        confirmUserSafeIpsTitle: 'Confirm User Safe Ips',
        confirmUserSafeIps: 'Confirm user safe ips',
        form: {
          addTitle: 'Add safe Ip',
          editTitle: 'Edit safe Ip',
        },
      },
      whiteMessages: {
        title: 'Requests list',
        form: {
          addTitle: 'Request new settings',
          editTitle: 'Edit request status',
          fields: {
            enterSms: 'Re-enter the club SMS',
            exitSms: 'Leaving club SMS',
            returnText: 'Return Text',
            cancelText: 'Cancel Text',
            status: 'Status',
            dailyAddLimit:
              'The maximum number of daily additions to the club book.',
            monthlyAddLimit:
              'The maximum number of monthly additions to the club book',
            isSendCancelText:
              'Send the cancellation text at the end of each SMS',
            rejectComment: 'Reject description',
            repeatTextDay: 'Repeat the text every day',
          },
          legends: {
            requestDetail: 'Request detail',
            defineScenario: 'Define scenario',
          },
        },
      },
      organizationWhiteMessages: {
        title: 'Settings list',
        form: {
          addTitle: 'Add Setting',
          editTitle: 'Edit setting',
          fields: {
            enterSms: 'Enter club SMS',
            exitSms: 'Leaving club SMS',
            returnText: 'Return text',
            cancelText: 'Cancel text',
          },
        },
      },
      sendWhiteMessage: {
        title: 'Send club SMS',
        editTitle: 'Edit Send club SMS',
        legends: {
          phonebook: 'Phonebook',
        },
      },
      aggregators: {
        title: 'Operator number',
        numberAggregator: 'Find number operator',
        isValidNumber: 'Is Valid Number',
        form: {
          addTitle: 'Add regex',
          editTitle: 'Edit regex',
          updateRegexTitle: 'Update Regex Title',
          fields: {
            regex: 'Regex',
            smsAggregator: 'Operator',
          },
        },
      },
      documentsManagement: {
        title: 'Documents management',
        form: {
          addTitle: 'Add document',
          editTitle: 'Edit document',
          fields: {},
        },
      },
      currentOrganizationSentCountStatistics: {
        title: 'Current Organization send Count statistics report',
      },
      currentUserSentCountStatistics: {
        title: 'Current user send Count statistics report',
      },
      sentCountStatistics: {
        title: 'Send Count Statistical report',
      },
      currentOrganizationSendStatusStatistics: {
        title: 'Statistical report of the status of the current organization',
      },
      currentUserSendStatusStatistics: {
        title: 'Statistical report of the status of the current user',
      },
      sendStatusStatistics: {
        title: 'Send Status Statistical report',
      },
      currentOrganizationOperatorStatistics: {
        title: 'Statistical report of current organization operators',
      },
      currentUserOperatorStatistics: {
        title: 'Statistical report of current user operators',
      },
      operatorStatistics: {
        title: 'Operator Statistics report',
      },
      complexStatistics: {
        title: 'Comprehensive statistical report',
      },
      currentOrganizationComplexStatistics: {
        title: 'Comprehensive statistical report of the current organization',
      },
      currentUserComplexStatistics: {
        title: 'Comprehensive statistical report of the current user',
      },
      todayStatistics: {
        title: 'Today Statistics report',
      },
      currentOrganizationTodayStatistics: {
        title: 'Todays statistical report of the current organization',
      },
      currentUserTodayStatistics: {
        title: 'Todays statistical report of the current user',
      },
      currentUserSentStatusSeasonsCompareStatistics: {
        title: 'Current user sent status seasons compare statistics',
      },
      currentUserSentStatusAggregateCompareStatistics: {
        title: 'Current user sent status aggregate compare statistics',
      },
      operatorSeasonsCompareStatistics: {
        title: 'Operator seasons compare statistics',
      },
      operatorAggregateCompareStatistics: {
        title: 'Operator aggregate compare statistics',
      },
      statisticalReports: {
        lineComplexDescription: 'Chart of total messages sent by time',
        doughnutChartDescription: 'Chart of the number of messages sent.',
        barChartDescription: 'Chart of messages sent',
        successful: 'Successful',
        unsuccessful: 'Unsuccessful',
        allCount: 'Total count',
        sendingStatusDoughnutChart: 'Sending status chart',
        sendingStatusBarChart: 'Chart of sending status by status',
        targetCount: 'Target SMS count',
        sentCount: 'Sent SMS count',
        untilTargetCount: 'Remaining count to target',
        lineResellersDescription:
          'The chart of sent SMS count and the target SMS count',
        barChartResellersDescription:
          'The chart of the total SMS sent and target count',
      },
      operatorsTodayStatistics: {
        title: 'Operators Today Statistics',
      },
      currentOrganizationResellersStatistics: {
        title: 'Organization resellers statistics',
      },
      packageSales: {
        title: 'SMS packages',
        form: {
          addTitle: 'Add SMS package',
          editTitle: 'Edit SMS package',
          priceErrorMessage:
            'The amount of charge must be more than the amount paid',
          fields: {
            expirationType: 'Expiration Type',
            expiration: 'Validity duration',
            depositPrice: 'Charge amount',
            packageInformations: 'Package informations',
            created: 'Creation time',
          },
        },
      },
      packageOrganizations: {
        title: 'SMS packages',
        expirationTypes: {
          0: 'Hour',
          1: 'Day',
          2: 'Week',
          3: 'Month',
        },
        expirationNames: {
          0: 'Hourly',
          1: 'Daily',
          2: 'Weekly',
          3: 'Monthly',
        },
        packageOrganizationsCard: {
          legend: 'Buy SMS package',
          discountCodeForOrganizationPackagePrice: 'Discount code',
          packageOrganizationPrice: 'SMS package price',
          buyPackage: 'Buy package',
          discountCode: 'Discount code',
          discountPercent: 'Discount percent',
          typeName: 'Package type',
          discount: 'Discount',
          expirationType: 'Expiration Type',
          organizationPackagePriceDetailsBought:
            'Specifications of the purchased SMS package',
          expiration: 'Type',
          wrongDiscountCodeMessage: 'The entered discount code is not correct',
          successfulDiscountSubmitation:
            'The discount code has been successfully registered.',
        },
      },
      privateNumbersPrice: {
        title: 'Numbers Prices',
        form: {
          addTitle: 'Add Number Price',
          editTitle: 'Edit Number Price',
          fields: {
            isRound: 'Is Round',
            numberOfDigits: 'Number length',
            reservationPeriod: 'Reservation days',
            reservationPeriodWithoutDay: 'Reservation time',
          },
          legends: {
            privateNumberPriceInformation: 'Buy number details',
          },
          messages: {
            alert1:
              'If you select <b class="tw-font-bold">Rand number</b>, <b class="text-danger">if the type of rand is specified</b>. (for example: 2-digit rouand)',
            alert2:
              'If you choose zero for the reservation period, the reservation period will not be reserved.',
          },
        },
      },
      privateNumbersPriceForUser: {
        title: 'Buy number for users',
        form: {
          fields: {
            isRound: 'Is round',
            numberOfDigits: 'Number length',
            reservationPeriod: 'Reservation days',
            reservationPeriodWithoutDay: 'Reservation time',
            privateNumberPriceNumber: 'Number',
            numberPrice: 'Number price',
          },
          legend: 'Buy number',
          messages: {
            privateNumberPriceDetailsBought: 'Details of the purchased line',
            privateNumberPriceAuthenticationAfterBuy:
              'Dear user, to send SMS with this number, it is necessary to authenticate the line',
            privateNumberPriceAuthentication:
              'Dear user, after purchasing the line, it is necessary to authenticate the purchased line.',
            privateNumberPriceNumber: 'Enter your desired line number',
            discountCodeForPrivateNumberPrice:
              'If you have a discount code to buy, enter it',
            PrivateNumberPriceWithoutAuthentication:
              'Note that it is not possible to use unauthenticated lines.',
            PrivateNumberPriceDeleteOrCancel:
              '<span class="text-danger">*</span> <span>The request for registering the selected census <b class="text-danger">cannot</b> be changed, deleted, or canceled. Therefore, please be careful and considerate regarding this matter.</span>',
            PrivateNumberPriceDeleteOrCancelAfterBuy:
              '<span class="text-danger">*</span> <span>Thank you for your good choice. Please be informed that the selected census registration request <b class="text-danger">cannot</b> be changed, deleted, or canceled. Therefore, please be careful and considerate regarding this matter.</span>',
          },
        },
        rules: {
          buyNumberRule1:
            'It does not conflict with the principles and foundations of Islam and the Constitution of the Islamic Republic of Iran.',
          buyNumberRule2: 'Do not cause anxiety in the society.',
          buyNumberRule3: 'Do not disturb the order and peace of the society.',
          buyNumberRule4: 'Do not harm the good morals of the society.',
          buyNumberRule5:
            'It does not conflict with the cultural, social and economic policies of the country.',
          buyNumberRule6:
            'It should not be contrary to the principles of elections and laws governing the society.',
          buyNumberRule7:
            'Not inciting, encouraging, persuading, threatening or inviting corruption and prostitution and committing crimes against chastity or sexual perversions (Computer Crimes Law and Article 639 of the Islamic Penal Code)',
          buyNumberRule8:
            'Non-proliferation of obscenity and obscenities in the society (paragraph 2, article 6 of the press law)',
          buyNumberRule9:
            'Failure to publish, distribute and trade content against public modesty (vulgar and obscene) (paragraph 2, article 6 of the Press Law and article 14 of the Computer Crimes Law) inciting, encouraging, persuading, threatening or enticing people to access obscene and vulgar contents (Article 515 of the Computer Crimes Law)',
          buyNumberRule10:
            'Not insulting Imam Khomeini (RA) and distorting her works (Article 514 of the Islamic Penal Code)',
          buyNumberRule11:
            'Not insulting the Supreme Leader and other imitation authorities (Clause 7, Article 6 of the Press Law)',
          buyNumberRule12:
            'Not publishing content against the principles of the Constitution (paragraph 12, article 6 of the Press Law)',
          buyNumberRule13:
            'Non-disclosure and unauthorized publication of the secrets of the armed forces and maps and military fortifications (Paragraph 6, Article 6 of the Press Law)',
          buyNumberRule14:
            'Not publishing any content with the aim of encouraging people to boycott or reduce participation in the elections (paragraphs 3 and 8 of Article 66 of the Election Law of the Islamic Council and Article 46 of the Executive Regulations)',
          buyNumberRule15:
            'Complying with all content rules of digital publication (rules for presenting digital cultural products)',
          buyNumberRule16:
            'It is prohibited to publish digital content that violates the principles of Islam and public rights as follows:',
          buyNumberRule16_1:
            'Destruction of national identity and mockery of religious beliefs, rituals and languages',
          buyNumberRule16_2:
            'Promoting social anomalies, social phenomena and subcultures that are contrary to Islamic Sharia',
          buyNumberRule16_3:
            'Propagation and promotion of deviant sects, false mysticism and lifestyles that are against Islamic Sharia',
        },
      },
      childrenPrivateNumberBuyRequests: {
        title: 'Number buy requests',
        updateStatusPrivateNumberPriceTitle:
          'Edit line purchase request status',
        form: {
          fields: {
            rejectionDescription: 'Reject description',
            payAmount: 'Pay Amount',
            isAllowedSendLink: 'Send link allow',
            isService: 'Service',
            privateNumberPriceIsRound: 'Round number',
            privateNumberPriceNumberOfDigits: 'Number length',
            privateNumberPriceTitle: 'Number title',
            reservationDate: 'Reservation date',
            assignmentDate: 'Assignment date',
            cancellationDate: 'Cancel date',
          },
        },
      },
      privateNumberBuyRequests: {
        title: 'Number Buy Requests',
        form: {
          fields: {
            rejectionDescription: 'Reject Description',
            payAmount: 'Pay Amount',
            isAllowedSendLink: 'Send Link Allow',
            isService: 'Service',
          },
        },
        privateNumberUploadDocuments: {
          title: 'Documents',
          form: {
            title: 'Document',
            addTitle: 'Add Title',
            fields: {
              FoundedAnnounce: 'Founded Announce',
              CertificateAddedValue: 'Certificate Added Value',
              CompanyStatute: 'Company Statute',
              MinutesCompanyChanges: 'Company Changes Minutes',
              NationalCard: 'National Card',
              BirthCertificate: 'Birth Certificate',
              documentStatus: 'Document Status',
              description: 'Description',
            },
          },
        },
        privateNumberDocuments: {
          title: 'Documents',
          form: {
            title: 'Document',
            addTitle: 'Add Document',
            legend: 'Documents',
            fields: {
              FoundedAnnounce: 'Founded Announce',
              CertificateAddedValue: 'Certificate Added Value',
              CompanyStatute: 'Company Statute',
              MinutesCompanyChanges: 'Company Changes Minutes',
              NationalCard: 'NationalCard',
              BirthCertificate: 'Birth Certificate',
              documentStatus: 'Status',
              description: 'Description',
            },
          },
        },
      },
      organizationPackages: {
        title: 'Organization Packages',
        depositPrice: 'Charge amount',
        expirationDate: 'Expire Date',
        purchaseDate: 'Purchase Date',
        cancelPackage: 'Cancel Package',
        remainingCredit: 'Remaining Credit',
      },
      childrenOrganizationsPackages: {
        title: 'Sub Organizations Packages',
        depositPrice: 'Charge amount',
        expirationDate: 'Expire Date',
        purchaseDate: 'Purchase Date',
        created: 'Creation date ',
        remainingCredit: 'Remaining Credit',
      },
      landingPageList: {
        title: 'Landing pages',
        form: {
          fields: {
            shortUrl: 'Short url',
          },
        },
      },
      readyTemplates: {
        title: 'Ready templates',
        form: {
          fields: {
            templatePreview: 'Template preview',
          },
        },
      },
      landingPage: {
        title: 'Landing Page',
        goFullScreen: 'Go Full Screen',
        exitFullScreen: 'Exit Full Screen',
        desginer: 'Desginer',
        cssEditor: 'Css editor',
        jsEditor: 'Javascript editor',
        compileAndInjectScss: 'Compile and inject to the page',
        injectJs: 'Inject JavaScript code into the page',
        previewInDesktop: 'Preview In Desktop',
        previewInTablet: 'Preview In Tablet',
        previewInMobile: 'Preview In Mobile',
        previewMode: 'Preview Mode',
        emptyDesignArea: 'Empty Design Area',
        htmlEditor: 'Html editor',
        selectFromTemplates: 'Select From Templates',
        saveLandingPage: 'Save Landing Page',
        saveAsTemplate: 'Save As Template',
        save: 'Save',
        ok: 'Ok',
        isPublic: 'Is Public',
        templatePreview: 'Template Preview',
        readyTemplateImported: 'Ready Template Imported',
        readyTemplateSaved: 'Ready Template Saved',
        landingPageSaved: 'Landing Page is Saved',
        selectTemplatePreview: 'Select Preview Template',
      },
      voiceMessagesGroup: {
        title: 'Voice messages group',
        form: {
          editTitle: 'Edit voice message group',
          addTitle: 'Add voice message group',
        },
      },
      voiceMessages: {
        title: 'Voice Messages List',
        form: {
          addTitle: 'Add voice Messages',
          editTitle: 'Edit voice Messages',
          fields: {
            voiceFile: 'Voice File',
            voiceText: 'Voice Text',
            sendingMethod: 'Sending ethod',
          },
          legends: {
            voiceInformation: 'Voice Information',
            uploadVoiceFile: 'Upload Voice File',
            voiceReader: 'Voice Reader',
          },
          messages: {
            generalExplanation:
              '<span> ● To create an audio file, first choose a title for your audio file.</span><span class="tw-mt-1"> ● Next, you can upload using one of the sending methods. File</b> or <b>Avakhan (text-to-speech tool) </b>Create your audio file.</span><b class="text-danger tw-mt-1"> ● Note that every SMS section is equivalent to 30 seconds.</b>',
            fileUploadGuid:
              '<span> ● In this method, you can upload your audio file.</span><span> ● The allowed format of the audio file is <b>MP3, WAV</b> and the maximum file size<b> is 5 MB. </b>is.</span>',
            textToVoiceGuid:
              '<span> ● To create an audio file, first choose a title for your audio file.</span><span class="tw-mt-1"> ● Next, you can upload using one of the sending methods. File</b> or <b>Avakhan (text-to-speech tool) </b>Create your audio file.</span><b class="text-danger tw-mt-1"> ● Note that every SMS section is equivalent to 30 seconds.</b>',
          },
        },
        textToVoiceConvertor: {
          delay: 'تاخیر',
          kasre: 'کسره',
          fathe: 'فتحه',
          zame: 'ضمه',
          tashdid: 'تشدید',
          sokoon: 'سکون',
        },
      },
      medias: {
        title: 'Media List',
        form: {
          addTitle: 'Add media',
          editTitle: 'Edit media',
          fields: {
            fileSizePerKilobyte: 'File size per kilobyte',
            fileTypes: 'Social media file types',
            url: 'Url',
          },
        },
        textToVoiceConvertor: {
          delay: 'تاخیر',
          kasre: 'کسره',
          fathe: 'فتحه',
          zame: 'ضمه',
          tashdid: 'تشدید',
          sokoon: 'سکون',
        },
      },
      resellerUsers: {
        title: 'Reseller Users List',
        form: {
          addTitle: 'Add reseller user',
          editTitle: 'Edit reseller user',
          fields: {
            isActiveSend: 'Is Active Send',
            isAdmin: 'Is Admin',
            isAuthenticated: 'Is Authenticated',
            parentOrganizationName: 'Parent Organization Name',
            roles: 'Roles',
            foreignerCode: 'Foreigner code',
            zoneId: 'Zone',
            password: 'Password',
            secondPassword: 'Second password',
            isAuthenticatedMobile: 'Is authenticated mobile',
            roleTemplateId: 'Role template',
            nationalCode: 'National code',
            isSendSmsDescriptionRequired: 'Is send sms description required?',
          },
          legends: {
            personalInformation: 'Personal information',
            systemInformation: 'System information',
            authentication: 'Authentication',
            roleInformation: 'Roles',
          },
        },
      },
      resellerOrganization: {
        title: 'Reseller Organization',
        organizationsExcel: 'Download resellers organization excel',
        form: {
          fields: {
            isActiveSend: 'Activated Sending',
            isActive: 'IsActive',
            isRealPerson: 'IsRealPerson',
            isAuthenticated: 'Is Authenticated',
            groupPriceCategoryTitle: 'Group Price',
            groupPriceTitle: 'Period',
            domainName: 'Domain name',
            panelPrice: 'Panel price',
            isPostpaid: 'Is post paid',
          },
        },
      },
      discount: {
        title: 'Discount Codes',
        form: {
          addTitle: 'Add discount',
          editTitle: 'Edit discount',
          fields: {
            discountCode: 'Discount code',
            discountType: 'Discount type',
            isPercentage: 'Is percentage',
            discountPercentageValue: 'Discount percentage value',
            discountValue: 'Discount value',
            maximumAmount: 'Maximum amount',
            maximumUse: 'Maximum use',
            discountInformation: 'Discount information',
          },
          legends: {
            discountInformation: 'Discount information',
          },
        },
      },
      excelRequest: {
        title: 'Excel request',
        form: {
          changeStatusTitle: 'Change status',
          fields: {
            path: 'Path',
            type: 'Type',
            isReadyForDownload: 'Is ready for download',
            errors: 'Errors',
          },
        },
      },
      plans: {
        title: 'Plans',
        plansManagementTitle: 'Plans management',
        form: {
          addTitle: 'Create plan',
          editTitle: 'Edit plan',
          legends: {
            planSpecifications: 'Plan specifications',
            modules: 'Modules',
          },
          fields: {
            planType: 'Plan type',
            extentionPrice: 'Extention price',
          },
        },
        planListModuleForUser: {
          title: 'Buy plan',
          form: {
            legend: 'Buy plan',
            PlanModuleBought: 'Specifications of the bought plan module',
          },
        },
        planListPackageForUser: {
          title: 'Buy package',
          form: {
            legend: 'Purchase package',
            PlanModuleBought: 'Bought plan specification',
          },
        },
      },
      zonePostalCodes: {
        title: 'Zone postal codes',
        form: {
          addTitle: 'Create zone postal code',
          editTitle: 'Edit zone postal code',
          legend: 'Zone postal code information',
          fields: {
            otherCount: 'Other count',
            rightelCount: 'Rightel count',
            mtnCount: 'Irancell count',
            mciCount: 'Hamrah aval count',
          },
        },
      },
      informationUsersSeen: {
        title: 'Information users seen',
        fields: {
          seenDateTime: 'Seen datetime',
        },
      },
      sendSmartSmsToResidents: {
        title: 'Smart delivery to the residents of the area',
        createRequest: 'Create Request',
        errors: {
          mostSelectPolygon:
            'To register a request, you must specify at least one area on the map.',
        },
      },
      occasionScheduledMessage: {
        title: 'List of Occasional Sending Requests',
        form: {
          fields: {
            phonebookCustomFieldNameEn: 'Custom field',
            calenderEvent: 'Calendar event',
            toConsiderYear: 'To Consider Year',
            calenderOrganizationEvent: 'Organizational opportunity',
            dynamicTemplateTitle: 'Dynamic template',
            howManyDaysSendItBeforeDueDate:
              'Send SMS before the date of the event (day)',
          },
        },
      },
      shortLinks: {
        title: 'Short links',
        descendantTitle: 'Descendant short links',
        form: {
          addTitle: 'Create short link',
          legend: 'Short link',
          fields: {
            shortUrl: 'Short link',
            mainUrl: 'Main url',
            urlType: 'Url type',
          },
        },
      },
      phonebookFileProgresses: {
        title: 'Create contacts status',
        fields: {
          fileName: 'File name',
          status: 'Status',
          phonebookId: 'Phonebook id',
          phonebookName: 'Phonebook name',
          progressPercent: 'Progress percent',
          totalCount: 'Total count',
        },
      },
      customerClubDevice: {
        title: 'Customer club devices',
        form: {
          addTitle: 'Create customer club device',
          editTitle: 'Edit customer club device',
          detailTitle: 'Customer club device detail',
          legends: {
            generalInformation: 'General information',
            details: 'Answer',
            phonebooksList: 'Phonebooks list',
          },
          fields: {
            deviceId: 'Device id',
            webhookUrl: 'Webhook url',
            phonebookIdList: 'Phonebook list',
            delayType: 'Delay type',
            delayValue: 'Delay value',
            isShowDetail: 'Is show detail?',
          },
        },
      },
      customerClubDeviceNumbers: {
        title: 'Device numbers',
      },
      frontAudits: {
        title: 'Front audits',
      },
      calendarEvent: {
        title: 'Calendar events',
        calendarEvents: 'Calendar events',
        calenderOrganizationEvents: 'Occasions created by the organization',
        form: {
          addTitle: 'Create an occasion',
          editTitle: 'Edit the occasion',
          deleteTitle: 'Delete the occasion',
          detailTitle: 'Detail the occasion ',
          filterTitle: 'Filter the occasion',
          fields: {},
        },
      },

      sendOccasionSms: {
        title: 'Occasional posting ',
        legends: {
          messageInformation: 'Message details',
          phonebook: 'Phonebook',
        },
        fields: {
          howManyDaysSendItBeforeDueDate:
            'Send SMS before the date of the event (day)',
          calendarEvents: 'Calendar event',
          calenderOrganizationEvents: 'Occasion created by the organization',
          toConsiderYear: 'To Consider Year',
        },
      },

      smartSmsCampaigns: {
        title: 'Smart sms campaigns list',
        form: {
          addTitle: 'Add smart sms campaign',
        },
      },
      smartSmsClubs: {
        title: 'Smart sms clubs list',
        form: {
          addTitle: 'Add smart sms club',
          addNumbersTitle: 'Add numbers to club',
        },
      },
      numbersAggregator: {
        title: 'Numbers aggregator',
        numbersAggregatorList: 'Numbers aggregator list',
      },
      numbersBlackLists: {
        title: 'numbers black lists',
        numbersBlackListsList: 'Numbers black lists list',
      },
      contactsByCellPhone: {
        title: 'Contacts list',
        form: {
          editTitle: 'Edit contact',
          legend: 'Contact information',
          fields: {
            contactCreateType: 'Create type',
            job: 'Job',
            phonebookTypes: 'Phonebook types',
          },
          messages: {
            description:
              'Attention: By changing information, old values will replace with new values.',
          },
        },
      },
      fieldsManagement: {
        title: 'Fields management',
        form: {
          addTitle: 'Add field',
          editTitle: 'Edit field',
          legend: 'Field detail',
          fields: {
            fieldType: 'Field type',
            maxValue: 'Max value',
            minValue: 'Min value',
            maxLength: 'Max length',
            minLength: 'Min length',
            regexValidation: 'Regex validation',
            maxFileSizeByMegabyte: 'Max file size by megabyte',
          },
        },
      },
      formsManagement: {
        title: 'ّForms management',
        form: {
          addTitle: 'Add form',
          editTitle: 'Edit form',
          legend: 'form detail',
          fields: {
            fieldType: 'Field type',
            maxValue: 'Max value',
            minValue: 'Min value',
            maxLength: 'Max length',
            minLength: 'Min length',
            regexValidation: 'Regex validation',
            maxFileSizeByMegabyte: 'Max file size by megabyte',
            theme: 'Theme',
            field: 'field',
            order: 'Order',
          },
        },
      },
      smartSmsNumberClasses: {
        title: 'Classes list',
        form: {
          addTitle: 'Add class',
          editTitle: 'Edit class',
          legend: 'Class information',
          fields: {
            operatorClasses: 'Operator classes',
          },
        },
      },
      checkNumberClassResponses: {
        title: 'Requests list',
        form: {
          addTitle: '',
          editTitle: '',
          fields: {
            checkTime: 'Check time',
          },
        },
      },
      onlineSurveyList: {
        title: 'Online surveys list',
      },
      onlineSurveyResponses: {
        title: 'Online surveys responses',
      },
      onlineSurveyStatistics: {
        title: 'Online surveys statistics',
      },
      createSmsInformation: {
        title: 'Send information',
      },
      processTextResults: {
        title: 'Process text results',
      },
    },
    enums: {
      Desktop: {
        MainDesktop: 'Main desktop',
        OrangeDesktop: 'Orange desktop',
        WindowsDesktop: 'Windows desktop',
        AndroidDesktop: 'Android desktop',
        Default: 'Default',
        Dark: 'Dark',
      },
      LoginTheme: {
        Default: 'Default',
        Dark: 'Dark',
      },
      ComparisonOperator: {
        EqualTo: 'Equal to',
        NotEqualTo: 'Not equal to',
        GreaterThan: 'Greater than',
        GreaterThanOrEqual: 'Greater than or equal',
        LessThan: 'Less than',
        lessThanOrEqual: 'Less than or equal',
        Contains: 'Contains',
        NotContains: 'Not contains',
        StartsWith: 'Starts with',
        EndsWith: 'Ends with',
      },
      SenderAgentType: {
        SMS: 'SMS',
        MMS: 'MMS',
        Email: 'Email',
        Voice: 'Voice',
      },
      SmsCp: {
        Magfa: 'Magfa',
        Asanak: 'Asanak',
        Armaghan: 'Armaghan',
        RahyabRG: 'Rahyabrg',
        RahyabPG: 'Rahyab pg',
        SLS: 'SLS',
        Shreeweb: 'ShreeWeb',
        SocialNetworks: 'Social networks',
        Avanak: 'Avanak',
        Gama: 'Gama',
        PishgamRayan: 'Pishgamrayan',
      },
      TypePrivateNumber: {
        Bulk: 'Bulk',
        InteractiveBulk: 'Inter active bulk',
        SmsMT: 'SmsMt',
        SmsMO: 'SmsMo',
        USSDMT: 'Ussdmt',
        USSDMO: 'Ussdmo',
        OPT: 'Opt',
      },
      SendPriority: {
        Lowest: 'Lowest',
        VeryLow: 'Very low',
        Low: 'Low',
        Normal: 'Normal',
        AboveNormal: 'Above normal',
        High: 'High',
        VeryHigh: 'Very high',
        Highest: 'Highest',
      },
      PrivateNumberUseForm: {
        OneNumber: 'One number',
        Mask: 'Mask',
        RangeNumber: 'Range number',
      },
      ZoneType: {
        Country: 'Country',
        Province: 'Province',
        City: 'City',
        Area: 'Area',
      },
      PeriodTypeValue: {
        Minute: 'Minute',
        Hour: 'Hour',
        Daily: 'Daily',
        Weekly: 'Weekly',
        Monthly: 'Monthly',
        Yearly: 'Yearly',
      },
      SmsSentPeriodType: {
        Minute: 'Minute',
        Hour: 'Hour',
        Daily: 'Daily',
        Weekly: 'Weekly',
        Monthly: 'Monthly',
        Yearly: 'Yearly',
      },
      PeriodType: {
        Minute: 'Minute',
        Hour: 'Hour',
        Daily: 'Daily',
        Second: 'Second',
      },
      SendSubTypes: {
        Direct: 'Direct',
        Gradual: 'Gradual',
        Periodic: 'Periodic',
        GradualPeriodic: 'Gradual periodic',
        Voice: 'Voice',
      },
      TypeBanks: {
        EghtesadNovin: 'Eghtesad novin',
        Pasargad: 'Pasargad',
        Parsian: 'Parsian',
        Tat: 'Tat',
        Tejarat: 'Tejarat',
        Saman: 'Saman',
        Sepah: 'Sepah',
        Shahr: 'Shahr',
        Saderat: 'Saderat',
        Mehr: 'Mehr',
        Keshavarzi: 'Keshavarzi',
        Gardeshgari: 'Gardeshgari',
        Maskan: 'Maskan',
        Mellat: 'Mellat',
        Melli: 'Melli',
      },
      SmartSmsStatus: {
        Done: 'Done',
        Failed: 'Failed',
        InternalError: 'Internal error',
        NotFound: 'Not found',
        Stored: 'Stored',
        Unknown: 'Unknown',
        Waiting: 'Waiting',
      },
      TypeIpGs: {
        Sadad: 'Sadad',
        BehPardakht: 'Behpardakht',
        Aap: 'Aap',
        Top: 'Top',
        Saman: 'Saman',
        Sepehr: 'Sepehr',
        IdPay: 'Idpay',
        IranKish: 'Irankish',
        Melli: 'Melli',
        ParbadVirtual: 'Parbad virtual',
        Parsian: 'Parsian',
        Pasargad: 'Pasargad',
        ZarinPal: 'Zarinpal',
        PayIr: 'Payir',
        Mellat: 'Mellat',
        AsanPardakht: 'Asan pardakht',
      },
      DeliveryStatus: {
        Unknown: 'Unknown',
        SentAndReceivedbyPhone: 'Sent and received by phone',
        HaveNotReceivedToPhone: 'Have not received to phone',
        SentToItc: 'Sent to itc',
        ReceivedByItc: 'Received by itc',
        DidNotReceiveToItc: 'Did not receive to itc',
        NotReceivebyServer: 'Not receive by server',
        ErrorInSending: 'Error in sending',
        WaitingForSend: 'Waiting for send',
        Sent: 'Sent',
        NotSent: 'Not sent',
        Expired: 'Expired',
        IsSending: 'Is sending',
        IsCanceled: 'Is canceled',
        BlackList: 'Blacklist',
        SmsIsFilter: 'SMS is filter',
        IsDeleted: 'Is deleted',
        WatingForConfirmation: 'Wating for confirmation',
        NotEnoughBalance: 'Not enough balance',
        IsPreparing: 'Is preparing',
        IsPreparedForSending: 'Is prepared for sending',
        AccessDenied: 'Access denied',
        TextIsEmpty: 'Text is empty',
        InvalidInputXml: 'Invalid input xml',
        InvalidUserOrPassword: 'Invalid user or password',
        InvalidUsedMethod: 'Invalid used method',
        InvalidSender: 'Invalid sender',
        InvalidMobile: 'Invalid mobile',
        InvalidReciption: 'Invalid reciption',
        Stored: 'Stored',
        BlackListTable: 'Blacklist table',
        GetDeliveryStatus: 'Get delivery status',
        InvalidPrivateNumber: 'Invalid private number',
        NotReceiveByPhone: 'Not receive by phone',
        NotReceivedByItc: 'Not received by Itc',
        DidNotReceivedByItc: 'Did not received by Itc',
        ReceivedByPhone: 'Received by phone',
      },
      SendStatus: {
        Unknown: 'Unknown',
        Sent: 'Sent',
        SentAndGiveBackCredit: 'Sent and give back credit',
        ErrorInSending: 'Error in sending',
        ErrorInGetItc: 'Error In get itc',
        BlackList: 'Blacklist',
        Stored: 'Stored',
      },
      MainSettings: {
        SendSmsAlertMessage: 'Send SMS alert message',
        AppPath: 'App path',
        RemoteQueueIp: 'Remote queue ip',
        DefaultNumber: 'Default number',
        IsRemoteQueue: 'Is remote queue',
        VasRegisterSmsText: 'Vas register SMS text',
        MaximumFailedTryCount: 'Maximum failed try count',
        RetrievePasswordSmsText: 'Retrieve password SMS text',
        RegisterFishMobiles: 'Register fish mobiles',
        OnlinePaymentSmsText: 'Online payment SMS text',
        UserExpireSmsText: 'User expire SMS text',
        RegisterFishSmsText: 'Register fish SMS text',
        ExportFileAddress: 'Export file address',
        Tax: 'Tax',
        AuthenticatedMobileSmsText: 'Authenticated mobile SMS text',
        LowestCreditOfUser: 'Lowest credit of user',
        ResolutionOfParliament: 'Resolution of parliament',
      },
      GenderType: {
        All: 'All',
        Man: 'Man',
        Woman: 'Woman',
      },
      SimType: {
        All: 'All',
        Credits: 'Credits',
        Permanent: 'Permanent',
      },
      FailureCode: {
        None: 'None',
        UserCreditNotEnough: 'User credit not enough',
        AdminCreditNotEnough: 'Admin credit not enough',
        PrivateNumberIsExpired: 'Private number is expired',
        UserIsInactive: 'User is in active',
        AdminIsInactive: 'Admin is in active',
        PrivateNumberNotValid: 'Private number not valid',
        NotDefineSmsRateType: 'Not define SMS rate type',
        SendError: 'Send error',
        UserCancelRequest: 'User cancel request',
        SystemIsOutOfService: 'System is out of service',
        SendTimeNotValid: 'Send time not valid',
        SmsTextIsFilter: 'SMS text is filter',
        UserIsExpired: 'User is expired',
        AdminIsExpired: 'Admin is expired',
        LinkIsNotAllowed: 'Link is not all owed',
        RecipientNotExist: 'Recipient not exist',
        ErrorCalculate: 'Error calculate',
        ErrorSelectNumber: 'Error select number',
        ErrorInSaveJob: 'Error in save job',
        ScheduledMessageNotFound: 'Scheduled message not found',
        OrganizationOrHierarchyIsInactive:
          'Organization or hierarchy is in active',
        GroupPriceIsNull: 'Group price is null',
        OrganizationCreditNotEnough: 'Organization credit not enough',
        OperatorNumberCountIsNull: 'Operator number count is null',
        OrganizationNotFound: 'Organization not found',
        NotSended: 'Not sended',
        OrganizationIsExpired: 'Organization is expired',
        PrivateNumberIsInactive: 'Private number is in active',
        OrganizationIsInactive: 'Organization is in active',
      },
      SendTypes: {
        Bulk: 'Bulk',
        Dynamic: 'Dynamic',
        P2P: 'P2p',
        Single: 'Single',
        PhoneBook: 'Phonebook',
        Api: 'Api',
      },
      QueueStatus: {
        Completed: 'Completed',
        Confirmed: 'Confirmed',
        Extracted: 'Extracted',
        Extracting: 'Extracting',
        Failed: 'Failed',
        FailedExtract: 'Failed extra ct',
        Ready: 'Ready',
        Rejected: 'Rejected',
        Stored: 'Stored',
        Updating: 'Updating',
        WatingForConfirm: 'Wating for confirm',
      },
      SmsAggregator: {
        NotValid: 'Not valid',
        MCI: 'Mci',
        MCI2: 'Mci2',
        Irancell: 'Irancell',
        Rightel: 'Rightel',
        Other: 'Other',
        International: 'International',
        // Taliya: '// taliya',
        // MTCE: '// mtce',
        // KishTCI: '// kish tci',
      },
      SmsLanguage: {
        Farsi: 'Farsi',
        Latin: 'Latin',
      },
      UseTypes: {
        Unknown: 'Unknown',
        Normal: 'Normal',
        WebService: 'Web service',
      },
      NumberType: {
        Public: 'Public',
        Private: 'Private',
        PrivateWithKeyword: 'Private with keyword',
      },
      TypeCreditChanges: {
        Manage: 'Manage',
        BuyPanel: 'Buy panel',
        ExtendedPanel: 'Extended panel',
        Fish: 'Fish',
        OnlinePayment: 'Online payment',
        PriceNumber: 'Price number',
        ActivationService: 'Activation service',
        GiveBackCostOfUnsuccessSent: 'Give back cost of unsuccess sent',
        ActivationGeneralPhoneBook: 'Activation general phonebook',
        SendSms: 'Send SMS',
        DeleteUser: 'Delete user',
        TransferPrivateNumber: 'Transfer private number',
      },
      TypeTransactions: {
        Increase: 'Increase',
        Decrease: 'Decrease',
      },
      UserDocuments: {
        BirthCertificate: 'Birth certificate',
        NationalCard: 'National card',
        OptionalField1: 'Optional field 1',
        OptionalField2: 'Optional field 2',
      },
      OrganizationDocuments: {
        BusinessLicense: 'Business license',
        CeoBirthCertificate: 'Ceo birth certificate',
        CeoNationalCard: 'Ceo national card',
        FoundedAnnounce: 'Founded announce',
        LatestChangesAnnounce: 'Latest changes announce',
        OptionalField1: 'Optional field 1',
        OptionalField2: 'Optional field 2',
      },
      DocumentStatus: {
        NotCheckedYet: 'Not checked yet',
        Accepted: 'Accepted',
        NotAccepted: 'Not accepted',
      },
      CustomFieldTypes: {
        Boolean: 'Boolean',
        Datetime: 'Date time',
        Float: 'Float',
        Integer: 'Integer',
        String: 'String',
      },
      TypePayments: {
        Cash: 'Cash',
        Cheque: 'Cheque',
        Card: 'Card',
        Account: 'Account',
        OnLine: 'Online',
      },
      TypePaymentStatus: {
        Confirmed: 'Confirmed',
        Rejected: 'Rejected',
        Checking: 'Checking',
        Lending: 'Lending',
        WatingForPay: 'Wating for pay',
      },
      OutBoxStatus: {
        Stored: 'Stored',
        WatingForSend: 'Wating for send',
        IsBeingSent: 'Is being sent',
        Sent: 'Sent',
        SentAndGiveBackCredit: 'Sent and give back credit',
        Archived: 'Archived',
        ErrorInSending: 'Error in sending',
        ErrorInGetItc: 'Error in get itc',
        BlackList: 'Blacklist',
        WatingForConfirm: 'Waiting for confirm',
        Archiving: 'Archiving',
      },
      Encoding: {
        English: 'English',
        Persian: 'Persian',
      },
      ExportDataStatus: {
        None: 'None',
        Get: 'Get',
        Complete: 'Complete',
        Refresh: 'Refresh',
      },
    },
    common: {
      lang: {
        fa: 'Fa',
        en: 'En',
      },
      dateTime: {
        minute: 'Minute',
        hour: 'Hour',
        day: 'Day',
        week: 'Week',
        month: 'Month',
        year: 'Year',
      },
      persianMonth: {
        Farvardin: 'Farvardin',
        Ordibehesht: 'Ordibehesht',
        Khordad: 'Khordad',
        Tir: 'Tir',
        Mordad: 'Mordad',
        Shahrivar: 'Shahrivar',
        Mehr: 'Mehr',
        Aban: 'Aban',
        Azar: 'Azar',
        Dey: 'Dey',
        Bahman: 'Bahman',
        Esfand: 'Esfand',
      },
      daysOfTheWeek: {
        saturday: 'Saturday',
        sunday: 'Sunday',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
      },
      calenderDate: {
        solar: 'Solar',
        ad: 'Ad',
        lunar: 'Lunar',
      },
      color: {
        red: 'Red',
        blue: 'Blue',
        purple: 'Purple',
        gray: 'Gray',
        white: 'White',
        green: 'Green',
        navyBlue: 'Navy Blue',
        yellow: 'Yellow',
        pink: 'Pink',
      },
      files: 'Files',
      replace: 'Replace',
      manual: 'Manual',
      noDataFound: 'No data found!',
      rial: 'Rial',
      allCount: 'All count',
      sendedCount: 'Sent count',
      row: 'Row',
      mobileNumbersCount: 'Mobile numbers count',
      changeMobileNumber: 'Change mobile number',
      name: 'Name',
      newName: 'New name',
      firstName: 'First name',
      lastName: 'Last name',
      fatherName: 'Father name',
      fullName: 'Full name',
      nationalCode: 'National code',
      messageCancelText: 'Message cancel text',
      level: 'level',
      nationalId: 'National id',
      showCalender: 'Show calender',
      selectedDaysCount: 'Selected days count',
      chooseSendDays: 'Choose send days',
      email: 'Email',
      street: 'Street',
      dehestan: 'Dehestan',
      neighbourhood: 'Neighbourhood',
      highway: 'Highway',
      freeway: 'Freeway',
      tunnel: 'Tunnel',
      square: 'Square',
      boulevard: 'Boulevard',
      university: 'University',
      county: 'County',
      park: 'Park',
      captcha: 'Captcha',
      chosen: 'Selected',
      retry: 'Retry',
      assignDate: 'Assign date',
      PrivateNumberCreated: 'Private number Created',
      SMSSignatureIsEnabled: 'SMS signature is enabled',
      faxNumber: 'Fax number',
      phone: 'Phone',
      referenceId: 'Reference id',
      occasionScheduledMessageId: 'Occasion scheduled message id',
      identityNumber: 'Identity number',
      birthDate: 'Birth date',
      gender: 'Gender',
      title: 'Title',
      group: 'Group',
      claimGroup: 'Claim group',
      active: 'Active',
      count: 'Count',
      file: 'File',
      activeSend: 'Active send',
      sendWithDuplicateNumbers: 'Send with duplicate numbers',
      credit: 'Credit',
      mobile: 'Mobile',
      select: 'Select',
      public: 'Public',
      private: 'Private',
      parentPublic: 'Parent public',
      year: 'Year',
      firstYear: 'First year',
      secondYear: 'Second year',
      month: 'Month',
      day: 'Day',
      text: 'Text',
      downloadLink: 'Download link',
      voiceFileDownloadLink: 'Voice file download link',
      voiceFile: 'Voice file',
      voiceMessage: 'Voice message',
      socialMediaApplication: 'Social media application',
      socialMediaMessage: 'Social media file',
      patch: 'Patch',
      receipt: 'Receipt',
      sender: 'Sender',
      farsi: 'Persian',
      latin: 'Latin',
      nonFarsi: 'Not Persian',
      data: 'Data',
      sms: 'SMS',
      part: 'Part',
      binary: 'Binary',
      userName: 'User name',
      password: 'Password',
      rePassword: 'Repassword',
      newRePassword: 'Repeat new password',
      show: 'Show',
      oldPassword: 'Old password',
      newPassword: 'New password',
      price: 'Price',
      number: 'Number',
      save: 'Save',
      maxSendCount: 'Max Send Count',
      allRecords: 'All records:',
      amount: 'Amount',
      notValid: 'Is not valid.',
      validMobile: 'Valid mobile',
      notValidMobile: 'Not valid mobile',
      setting: 'Setting',
      privateNumber: 'Private number',
      privateNumbers: 'Private numbers',
      isAuthenticated: 'Is authenticated',
      isAuthenticatedMobile: 'Is authenticated mobile',
      organizationName: 'Organization name',
      isForeigner: 'Is foreigner',
      id: 'Id',
      warning: 'Warning',
      login: 'Login',
      lockOut: 'Block',
      unblock: 'Unblock ',
      sendSubType: 'Send subType',
      sendSubDateType: 'Send subdate type',
      loginToUserAccount: 'Login to user account',
      loginOrganization: 'Login to organization',
      loginToAccount: 'Login to account',
      loginWithIdentity: 'Login with identity',
      signUpWithIdentity: 'Signup with identity',
      rememberMe: 'Remember me',
      forgetPassword: 'Forget password',
      editPassword: 'Edit password',
      signUp: 'Signup',
      goToLogin: 'Go to login',
      account: 'Account',
      receivers: 'Receivers',
      fastSend: 'Fast send',
      testSend: 'Test send',
      tableSetting: 'Table Setting',
      defaultGroupPrice: 'Default group price',
      PhonebookRecipient: 'Phonebook recipient',
      startDate: 'Start date',
      endDate: 'End date',
      description: 'Description',
      minPrice: 'Min price',
      maxPrice: 'Max price',
      typeBank: 'Type bank',
      operation: 'Operation',
      createDate: 'Create date',
      pattern: 'Pattern',
      messageInformation: 'Message information',
      sendDateTimeType: 'Send settings',
      confirmSmartSmsRequest: 'Confirm smart SMS request',
      justSendToWhiteList: 'Just send to white list',
      isFlashSms: 'Send flash sms',
      scheduledMessageId: 'Scheduled message id',
      lastModifiedDate: 'Last modified date',
      expireDate: 'Expire date',
      expireTime: 'Expire time',
      authenticated: 'Authenticated',
      addSingle: 'Add single',
      addListNumber: 'Add list number',
      addFromFile: 'Add from file',
      authenticatedMobile: 'Authenticated mobile',
      deleteAllContact: 'Delete all contact',
      columns: 'Columns',
      key: 'Key',
      creditPayment: 'CreditPayment',
      onlinePayment: 'OnlinePayment',
      value: 'Value',
      customText: 'Custom text',
      searchFilter: 'Search filter',
      userInfo: 'User info',
      userId: 'User id',
      userManual: 'User manual',
      createTemplate: 'Create template',
      numberList: 'Numbers list',
      generalIndexes:
        'If you enter general indexing, the above indices are not taken into account',
      bulkSendDetail: 'Bulk send detail',
      merchantId: 'Merchant id',
      terminalId: 'Terminal id',
      androidPreview: 'Android Preview',
      iosPreview: 'Ios Preview',
      terminalKey: 'Terminal key',
      userPassword: 'User Password',
      shaKey: 'SHA key',
      loginAccount: 'Login account',
      merchantCode: 'Merchant code',
      privateKey: 'Private Key',
      activationDate: 'Activation Date',
      acceptorId: 'Acceptor id',
      passPhrase: 'Pass phrase',
      publicKey: 'Public key',
      sendPrice: 'Sending Cost',
      privateCode: 'Private code',
      merchantConfigurationId: 'Receiver configuration number',
      creditNotEnough: 'Your credit is not enough!',
      generalUse: 'General use',
      usingTheInvoice: 'Using the invoice',
      generalIndexing: 'General indexing',
      invoice: 'Invoice',
      orderId: 'Order id',
      resellerName: 'Reseller name',
      date: 'Date',
      hour: 'Hour',
      appVersion: 'Application version',
      minute: 'Minute',
      pishgamRayanDadehPajoohCo: 'Pishgam Data Research Company',
      esfahan: 'Esfahan',
      phoneNumberFax: 'Phone number / Fax',
      postalCode: 'Postal code',
      pishgamRayanAddress:
        'حد فاصل چهار راه آپادانا و سپهسالار، جنب بانک تجارت، ساختمان تندیس، طبقه ۴، واحد۴۱',
      organization: 'Organization',
      getterOrganization: 'Getter organization',
      getterUser: 'Getter user',
      currentOrganization: 'Current organization',
      organizations: 'Organizations',
      shortcuts: 'Shortcuts',
      operator: 'Operator',
      smsEncoding: 'SMS encoding',
      domainId: 'Domain id',
      domainName: 'Domain name',
      parentId: 'Parentid',
      parentOrganization: 'Parent organization',
      user: 'User',
      deleteSelectedFile: 'Delete selected file',
      users: 'Users',
      chosenPhonebooks: 'Selected phonebook',
      userList: 'User list',
      organizationList: 'Organization list',
      senderNumberId: 'Sender number id',
      characterCount: 'Character count',
      smsBody: 'SMS body',
      claimsCount: 'Claims count',
      menusCount: 'Menus count',
      selectedCount: 'Selected count',
      enamad: 'Enamad',
      domainHeader: 'Header',
      convertToPersianNumbers: 'Convert to persian numbers',
      realPerson: 'Real person',
      legalPerson: 'Legal person',
      sendHour: 'Send hour',
      sendDay: 'Send day',
      startDay: 'Start day',
      position: 'Position',
      permissions: 'Permissions',
      signaturePosition: 'Signature position',
      organizationSignaturePosition: 'Organization signature position',
      organizationHeaderPosition: '',
      headerPosition: '',
      startTime: 'Start time',
      trustMark: 'Trust Mark',
      startHour: 'Start hour',
      endDay: 'End day',
      endTime: 'End time',
      endHour: 'End hour',
      partCount: 'Part count',
      campaign: 'Campaign',
      campaignId: 'Campaign id',
      groupPriceCategory: 'Group price category',
      environmentInfo: 'Environment info',
      logInfo: 'Log info',
      hello: 'Hello',
      selectedTheme: 'Selected theme',
      selectedTemplate: 'Selected template',
      privateNumberList: 'Private Number List',
      from: 'From',
      to: 'To',
      groupDeletion: 'Group deletion',
      groupEdit: 'Group edit',
      new: 'New',
      clickToShow: 'Click to show',
      phonebook: 'Phonebook',
      phonebooks: 'Phonebooks',
      accountInformation: 'Account information',
      accountInformationCardNo: 'Account information card no',
      NumberOfRecords: 'Number of records',
      NumberOfViews: 'Number of views',
      page: 'Page',
      username: 'User name',
      loading: 'Loading',
      error: 'Error',
      info: 'Info',
      type: 'Type',
      ipAddress: 'Ip address',
      browser: 'Browser',
      device: 'Device',
      os: 'Os',
      refreshToken: 'Refresh token',
      refreshTokenExpiration: 'Refresh token expiration',
      isActive: 'Is active',
      deActive: 'De active',
      loginToPanel: 'Login to panel',
      removeRule: 'Reomve Rule',
      modules: 'Modules',
      personType: 'Person type',
      yourCredit: 'Your credit',
      isPublic: 'Is public',
      isActiveSend: 'Is active send',
      isDefault: 'Is default',
      contactsCount: 'Contacts count',
      changeDefault: 'Change default',
      myOrganizations: 'My organizations',
      senderNumber: 'Sender number',
      defaultOrganization: 'Default organization',
      activeOrganization: 'Active organization',
      currentOrganizations: 'Current organizations',
      detail: 'Detail',
      mediaDetail: 'Media Detail',
      male: 'Male',
      female: 'Female',
      mci: 'Mci',
      mtn: 'Mtn',
      rightel: 'Rightel',
      confirmSend: 'Confirm send',
      rejectSend: 'Reject send',
      organizationId: 'Organization id',
      currentStatus: 'Current status',
      changeStatusTo: 'Change status to',
      deliveryStatus: 'Delivery status',
      partLength: 'Part length',
      sendTo: 'Send to',
      unknown: 'Unknown',
      dynamicTemplate: 'Dynamic template',
      selectField: 'Select field',
      defineDynamicTemplate: 'Define dynamic template',
      customField: 'Custom field',
      customFields: 'Custom fields',
      showDetails: 'Show details',
      English: 'English',
      Persian: 'Persian',
      format: 'Format',
      increase: 'Additive',
      decrease: 'Decrease',
      paymentId: 'Payment id',
      typeTransaction: 'Transaction Type',
      whiteMessageId: 'Customers club id',
      delete: 'Delete',
      edit: 'Edit',
      transferNumber: 'Transfer number',
      maxDailySendCount: 'Max daily send count',
      authenticate: 'Authenticate',
      uploadDocuments: 'Upload documents',
      fromIndex: 'From index',
      aggregator: 'Aggregator',
      toIndex: 'To index',
      documentation: 'Documentation',
      textBody: 'Text body',
      editStatus: 'Edit status',
      editStatusAll: 'Edit status all',
      editStatusAllReceivers: 'Edit status all receivers',
      getNewDeliveryStatus: 'Get new delivery status',
      editReceiversStatus: 'Edit receivers status',
      editDeliveryStatus: 'Edit delivery status',
      editDeliveryStatusByExcelFile: 'Edit delivery status by excel file',
      fileUpload: 'File upload',
      yes: 'Yes',
      no: 'No',
      ok: 'Ok',
      payment: 'Payment',
      discountCode: 'DiscountCode',
      discount: 'Discount',
      success: 'Success',
      nonSuccess: 'Unsuccessful',
      total: 'Total',
      signature: 'Signature',
      header: 'Header',
      smsCp: 'SMS sender agent',
      privateNumberSignature: 'Private number signature',
      privateNumberHeader: 'Private number header',
      organizationSignature: 'Organization signature',
      organizationHeader: 'Organization header ',
      selectFile: 'Select file',
      userOrganizations: 'User organizations',
      cancel: 'Cancel',
      selectAll: 'Select all',
      all: 'All',
      allDayOfWeeK: 'All day of week',
      every: 'All',
      lat: 'Lat',
      lon: 'Lon',
      distance: 'Distance',
      importanceLevel: 'Importance Level',
      notificationType: 'Notification type',
      distanceOnKm: 'Distance(Kilometers)',
      size: 'Size',
      closeAll: 'Close all',
      nextStep: 'Next step',
      close: 'Close',
      roles: 'Roles',
      roleTemplate: 'Roles template',
      smsParts: 'SMS parts',
      smsText: 'SMS text',
      smsBodyText: 'SMS text',
      keyword: 'Keyword',
      resendSMS: 'Resend SMS',
      twoFactorEnabled: 'Two factor enabled',
      resendSMSByDeliverStatus: 'Resend SMS by deliver status',
      resendDetail: 'Resend detail',
      address: 'Address',
      zipCode: 'Zip code',
      myCredit: 'My credit',
      currentUserCredit: 'Current user credit',
      organizationCredit: 'Organization credit',
      updateCredit: 'Up date credit',
      status: 'Status',
      submit: 'Submit',
      confirm: 'Confirm',
      back: 'Back',
      up: 'Up',
      down: 'Down',
      sentDateTime: 'Sending Date',
      groupPriceList: 'Group price list',
      rangeList: 'Range list',
      endOfSmsBody: 'End of SMS body',
      startOfSmsBody: 'Start of SMS body',
      reporting: 'Reporting',
      reportBuilder: 'Report Builder',
      report: 'Report',
      search: 'Search',
      searchPlace: 'Social places',
      advancedSearch: 'Advance search',
      groupPrice: 'Group price',
      add: 'Add',
      privateNumberPurchaseRules: 'Private number purchase rules',
      currency: 'Rial',
      currencyWithParentheses: 'Rial',
      addUser: 'Add user',
      toman: 'Toman',
      nextLevel: 'Next level',
      sendAuthCode: 'Send authentication code',
      increaseCredit: 'Increase credit',
      decreaseCredit: 'Decrease credit',
      creditTransfer: 'Credit transfer',
      play: 'Play',
      pause: 'Pause',
      downloadFile: 'Download file',
      download: 'Download',
      downloadExcel: 'Download excel',
      downloadExcelWithMoreDetail: 'Download excel with more detail',
      generalDisplay: 'General display',
      groupPriceDetail: 'Group price detail',
      displayMode: 'Display mode',
      displayWithDetails: 'Display with details',
      udhLen: 'Persian character separator length status',
      print: 'Print',
      downloadAll: 'Download all',
      saveToCampaign: 'Save to campaign',
      authCode: 'Authentication code',
      clearAll: 'Clear all',
      clear: 'Clear',
      removeAll: 'Remove all',
      empty: 'Empty',
      confirmation: 'Confirmation',
      priority: 'Priority',
      notConfirmation: 'Not confirmation',
      clipBoard: 'Clipboard',
      onBackToPreviousAccount: 'On back to previous account',
      language: 'Language',
      darkMode: 'Dark mode',
      lightMode: 'Light mode',
      privateNumberId: 'Sender id',
      notifications: 'Notifications',
      logout: 'Logout',
      unreadMessages: 'Unread messages',
      allMessages: 'All messages',
      token: 'Token',
      resend: 'Resend',
      continuation: 'Continuation',
      sendSubmit: 'Send submit',
      quickLinks: 'Quick links',
      refresh: 'Refresh',
      refreshMenus: 'Refresh menus',
      menus: 'Menus',
      buy: 'Buy',
      claims: 'Claims',
      sendSms: 'Send SMS',
      editSendSms: 'Edit send SMS',
      cpType: 'sms Cp',
      specifications: 'Specifications',
      titleAndTextHelp: 'Title and Text',
      wordList: 'Word list',
      send: 'Send',
      changePassword: 'Change password',
      useType: 'Use type',
      changeOrganization: 'Change organization',
      country: 'Country',
      state: 'State',
      province: 'province',
      city: 'City',
      area: 'Area',
      mobilePrefix: 'Mobile prefix',
      bank: 'Bank',
      field: 'Field',
      owner: 'Owner',
      SelectedPhonebooks: 'Selected phonebooks',
      clickForMoreInfo: 'Click for more info',
      help: 'Help',
      attachment: 'Attachment',
      example: 'Example',
      notFoundHelp: 'Not found help',
      mainClaim: 'Main claim',
      class: 'Class',
      icon: 'Icon',
      minuteBetweenTries: 'Time between tries',
      transferPrivateNumber: 'Transfer private number',
      maxTryCount: 'Max try count',
      zero: 'Zero',
      parent: 'Parent',
      parentName: 'Parent name',
      database: 'Database',
      paymentAmount: 'Payment amount',
      chargeRateCredit: 'Charge rate credit',
      table: 'Table',
      recipientCount: 'Recipient count',
      apiAddress: 'Api address',
      finalConfirmation: 'Final confirmation',
      startDateSearch: 'Start date search',
      startTimeSearch: 'Start time search',
      cancellation: 'Cancel',
      cancellationRequest: 'Cancel request',
      stayRequest: 'I will wait',
      endDateSearch: 'End date search',
      endTimeSearch: 'End time search',
      dateExit: 'Date exit',
      totalSum: 'Total sum',
      currentPageTotalSum: 'Current page total sum',
      openDateFilter: 'Open date filter',
      deleteFilter: 'Delete filter',
      addRule: 'Add Rule',
      copyContent: 'Copy content',
      pasteContent: 'Paste content',
      copy: 'Copy',
      expandAll: 'Expand all',
      payable: 'Payable',
      collapseAll: 'Collapse all',
      paste: 'Paste',
      nameFa: 'Name fa',
      nameEn: 'Name en',
      transactions: 'Transactions',
      transactionKind: 'Transaction kind',
      sendType: 'Sending type',
      nowNo: 'Not now',
      succeed: 'Succeed',
      publicPlace: 'Public place',
      link: 'Link',
      fileLink: 'File link',
      shortLinkList: 'Short link list',
      smsTemplateList: 'Sms Template list',
      emoji: 'Emoji',
      optional: 'Optional',
      savePolygon: 'Save polygon',
      extraReceivers: 'Extra receivers',
      reseller: 'Reseller',
      addPublicPlace: 'Add Public Place',
      resetPassword: 'Reset password',
      isSignOut: 'Is signout',
      removeSelectedItems: 'Remove selected items',
      signInSignOut: 'SignIn/SignOut',
      emptyReceivers: 'The recipient list is empty.',
      emptyReceiversOrWrongIndex:
        'The recipient list is empty or the indexing is wrong',
      uploadFile: 'Upload file',
      uploadImage: 'Upload image',
      uploadBackground: 'Upload background',
      isConfirmed: 'Is confirmed',
      inboxGroup: 'Inbox group',
      saveNow: 'Save now',
      saveNowAfterSend: 'Save after sending',
      check: 'Check',
      myOrganizationPackages: 'My packages',
      getNewStatus: 'Get the latest status',
      guildName: 'Guild name',
      subGuildName: 'Subguild name',
      frontAudits: 'Front audits',
      pollParserInboxes: 'Poll parser inboxes',
      receiveDateTime: 'Receive DateTime',
      smsCount: 'SMS count',
      priceRial: 'Price (rial)',
      statistics: 'Statistics',
      pollParserLottery: 'Lottery',
      winnerList: 'Winner list',
      winnerCount: 'Winner count',
      addToQueue: 'Add to queue',
      ip: 'Ip',
      ipRange: 'Ip range',
      currentIp: 'Current Ip',
      appearanceSettings: 'Appearance Settings',
      formDetails: 'Form Details',
      useToCreateToken: 'Use to create token',
      useToLoginPanel: 'Use to login panel',
      running: 'Active',
      paused: 'Inactive',
      do_pause: 'Disable',
      do_play: 'Enable',
      persianPrice: 'Persian price',
      startDateTime: 'Start date time',
      endDateTime: 'End date time',
      expireDateTime: 'Expire date time',
      englishPrice: 'English price',
      chosenSmartSmsDetail: 'Smart sms detail',
      numbersCount: 'Numbers count',
      statusDatetime: 'Status date time',
      lastUpdateDatetime: 'Last update date time',
      isNeedUserConfirmation: 'Is need user confirmation?',
      addNumbers: 'Add numbers',
      numbers: 'Numbers',
      deliveryStatusStats: 'Message delivery status statistics',
      messageDeliveryStatusStats: 'Message delivery status statistics',
      nextMonth: 'Next Month',
      previousMonth: 'Previous Month',
      groupConfirmation: 'Group confirmation',
      buyPlan: 'Buy plan',
      occasion: 'Occasion',
      calendar: 'Calendar',
      holiday: 'Holiday',
      organExpireDate: 'Organization expiration date',
      userExpireDate: ' days left until user expires ',
      chart: 'Chart',
      simType: 'Sim type',
      requestDetail: 'Request detail',
      isRandomSend: 'Is random send',
      smsPreview: 'Sms Preview',
      addToPublicPlace: 'Add to public place',
      balance: 'Balance',
      isCountTargetPassed: 'Count reached',
      isCreditTargetPassed: 'Credit reached',
      creditTargetValue: 'Final amount',
      countTargetValue: 'Number of SMS',
      times: 'Times',
      commission: 'Commission',
      partsCount: 'Number of parts',
      target: 'Target',
      encoding: 'Encoding',
      stats: 'Statistics',
      justCurrentOrganization: 'Just current organization',
      geometryType: 'Geometry type',
      grayList: 'Gray list',
      airports: 'Airports',
      requestType: 'Request Type',
      smsSendingNumber: 'Sms sending number',
      isRead: 'Is read',
      informationUsersSeen: 'Information users seen',
      receivedMessage: 'Received message',
      startTimeAtDay: 'Start time at day',
      endTimeAtDay: 'End time at day',
      update: 'Update',
      messageCount: 'Messages count',
      messageInConsumeCount: 'Message in consume count',
      regex: 'Regex',
      priceFa: 'Price(FA)',
      priceEn: 'Price(EN)',
      totalPriceFa: 'Total price(FA)',
      totalPriceEn: 'Total price(EN)',
      expandMap: 'Expand Map',
      collapseMap: 'Collapse Map',
      incomeRatePerSecond: 'Income rate per second',
      consumersCount: 'Consumers count',
      consumeRatePerSecond: 'Consume rate per second',
      duplicatedNumbersCount: 'Duplicated numbers count',
      archive: 'Archive',
      smartSmsPercent: 'Smart sms percent',
      mtnSmartPercent: 'Mtn smart percent',
      rightelSmartPercent: 'Rightel smart percent',
      mciSmartPercent: 'Mci smart percent',
      smartSmsClubTitle: 'Smart sms club title',
      smartSmsCampaignTitle: 'Smart sms Campaign title',
      periodType: 'Period type',
      period: 'Period',
      periodValue: 'Period value',
      smartRequestType: 'Smart request type',
      grayListExpireHour: 'Gray list expire hour',
      cellList: 'Cell list',
      isSmartCountAsPercent: 'Is smart count as percent',
      smartSmsClubOperationType: 'Smart sms club operation type',
      downloadPDF: 'download PDF',
      downloadPowerPoint: 'download Powerpoint',
      downloadImage: 'download Image',
      smartRequestId: 'Request id',
      megabyte: 'Megabyte',
      kilobyte: 'Kilobyte',
      chooseTemplate: 'Choose Template',
      chooseTheme: 'Choose Theme',
      titleOfReport: 'Title of the report',
      logoUpload: 'Logo Uploader',
      imageUpload: 'Image uploader',
      campaignReport: 'Campaign Report',
      editTitleOfReport: 'Edit title of Report',
      createReport: 'Create Report',
      editBackground: 'Edit Background ',
      operators: 'Operators',
      sendStatus: 'Send status',
      readNotification: 'Read notification',
      percentage: 'Percentage',
      addTitle: 'Add title',
      showFile: 'Show files',
      addRow: 'Add row',
      socialMediaGroupPriceDetail: 'Social media group price detail',
      groupRejection: 'Group rejection',
      financialBalance: 'Financial balance',
      paymentImage: 'Payment image',
      passwordOrToken: 'Password or token',
      url: 'Url',
      aggregatorInquiry: 'Aggregator inquiry',
      blackListInquiry: 'Black lists inquiry',
      isBlackList: 'Is black list',
      isExternalBlackList: 'Is external black list',
      totalCount: 'Total count',
      getTotalCount: 'Get total count',
      startDatetime: 'Start date time',
      endDatetime: 'End date time',
      isCanSendVoice: 'Can send voice',
      activePeriodicSmartSmsRequests: 'Running campaigns',
      showMore: 'Show more...',
      isUseSeparator: 'Is use separator in number fields',
      scheduledMessagePartsCount: 'Scheduled message parts count',
      platform: 'Platform',
      endOfSessions: 'Finish the session',
      currentMeeting: 'Current session',
      numberType: 'Number type',
      sendToBlackList: 'Send to blacklist',
      deleteFilters: 'Delete filters',
      voiceMessageId: 'Voice message id',
      avanakVoiceMessageId: 'Avanak voice message id',
      isQuickSend: 'Is quick send',
      quickSendId: 'Quick send id',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      reversePolygon: 'Reverse polygon',
      desiredPolygon: 'Coordinates of desired areas',
      checkCell: 'Check cell',
      checking: 'Checking',
      season: 'Season',
      cellsByName: 'Get cells by name',
      names: 'Names',
      stopSending: 'Stop sending',
      cellListIds: 'Cell list ids',
      isCanSendSmartWithoutConfirmation:
        'Is can send smart without confirmation',
      region: 'region',
      pricePerPart: 'Price per part',
      calculate: 'Calculate',
      smartSmsClubFileProgresses: 'Smart sms club file progress',
      downloadResellerExcel: 'Download reseller excel',
      isPercentageBenefitForInternational:
        'Is percentage benefit for international?',
      internationalBenefitValue: 'International benefit value',
      campaignStatusInGateway: 'Campaign status in gateway',
      clubStatusInGateway: 'club status in gateway',
      isCreated: 'Is created?',
      creationLocation: 'Creation location',
      startLocation: 'ُStart location',
      updateGroup: 'Update group',
      voiceGroup: 'Voice group',
      continueSendIfAnyOperatorHaveError:
        'Continue send if any operator have error',
      kibanaDashboard: 'Kibana dashboard',
      authorizationScheme: 'Authorization scheme',
      organizationsBlackListExceptions: 'Organizations black list exceptions',
      loginAudits: 'Login audits',
      alertSetting: 'Alert setting',
      htmlContent: 'HTML content',
      showDashboard: 'Show dashboard',
      smartSmsClubNumbers: 'Smart sms club numbers',
      strategies: 'Strategies',
      pointStrategies: 'Point strategies',
      pointStrategiesDetail: 'Point strategies detail',
      deviceNumbers: 'Device numbers',
      histories: 'Histories',
      strategyTitle: 'Strategy title',
      backgroundImage: 'Background image',
      form: 'Form',
      items: 'Items',
      newMobileNumber: 'New mobile number',
      showForm: 'Show form',
      zoomToFit: 'Zoom to fit',
      reload: 'Reload',
      if: 'If',
      then: 'Then :',
      singleDelete: 'Single delete',
      deleteWithChildren: 'Delete with children',
      ifValue: 'Value :',
      responses: 'Responses',
      fieldType: 'Field type',
      answerResponse: 'Answer response',
      duplicationResponse: 'Duplication response',
      mobiles: 'Mobiles',
      emptyMobiles: 'Empty mobiles',
      addFromExistingFields: 'Add from existing fields',
      questionTitle: 'Question title',
      copyLink: 'Copy link',
      isPostPaid: 'Is post paid',
      word: 'Word',
      score: 'Score',
      rank: 'Rank',
      addMobile: 'Add mobile',
      notValidAnswersResponse: 'Not valid answers response',
      expiringOrganizationsCount: 'Number of expiring organizations',
      expiringUsersCount: 'Number of expiring users',
      expiringPrivateNumbersCount: 'Number of expiring lines',
      suspendedUsersCount: 'Number of suspended users',
      unAuthorizedUsersCount: 'Number of unauthenticated users',
      waitForConfirmApiTokensCount: 'Number of tokens being verified',
      waitForConfirmOtpsCount: 'Number of otps being verified',
      waitForConfirmPaymentsCount: 'Number of offline payments being verified',
      waitForConfirmSafeIpsCount: 'Number of IPs being verified',
      waitForConfirmScheduledMessagesCount:
        'Number of messages awaiting confirmation',
      canceledNotResentLocalNetworkOutboxMessageCount:
        'Registered messages with number 999999',
      totalRecipients: 'Total recipients',
    },
    messages: {
      clipboard: {
        message: 'Click to copy',
        copied: 'Copied',
      },
      htmlStatus: {
        code400: 'Invalid request',
        code401: 'Inaccessibility',
        code403: 'Inaccessibility',
        code404: '404',
        code405: 'Error',
        code500: 'Server error',
        code400Msg: 'Your request has encountered a problem',
        code401Msg: 'To continue the process, you need to log in first',
        code403Msg:
          'Dear user, you do not have permission to access this section',
        code405Msg: 'Sending error',
        code500Msg: 'There was a problem communicating with the server.',
      },
      validationError: {
        minLength:
          '<b>{{title}}</b> must be at least <b>{{minLength}}</b> characters',
        maxLength:
          '<b>{{title}}</b> must be at most <b>{{maxLength}}</b> characters',
        min: 'The value of <b>{{title}}</b> must not be less than <b>{{min}}</b>',
        max: 'The value of <b>{{title}}</b> must not exceed <b>{{max}}</b>',
        invalid: 'The mobile number is invalid',
        fieldIsInvalid: '<b>{{title}}</b> is invalid',
        required: 'Filling the <b>{{title}}</b> field is mandatory',
        globalRequired: 'Filling the field is mandatory',
        invalidEmail: 'The email address is not valid',
        maxFileSizeInMb:
          'The maximum file size allowed for uploading is {{size}} megabytes',
        maxFileSizeInKb:
          'The maximum file size allowed for uploading is {{size}} kilobytes',
        allowedFilTypes: 'Files with {{types}} extensions are allowed',
        confirmPassword: 'The repeated password does not match the password',
        allowedFilTypesTip: 'Allowed formats',
        fileMaxLengthInKB: 'File max length in kb',
        fileMaxLengthInGB: 'File max length in gb',
        validFileTypes: 'Valid file types',
        fileMaxLength: 'File max length',
        maxFileCount: 'Max file count is {{ count }}.',
        addAtLeastOneOption: 'Add at least one option',
        endDateShouldBiggerThanStartDate:
          'End date should be bigger than start date',
      },
      selectedFilters: 'Selected filters',
      selectedLoginPageTemplate:
        'Please select the login page template you want :',
      fewMinutesAgoWithMin: '{{min}} minutes ago',
      hoursAndMinutesAgo: '{{hours}} hours and {{minutes}} minutes ago',
      hoursAgo: '{{hours}} hours ago',
      daysAndHoursAndMinutesAgo: '{{days}} days and {{hours}} hours ago',
      daysAgo: '{{days}} days ago',
      monthsAgo: '{{month}} months ago',
      yearsAgo: '{{year}} years ago',
      momentsAgo: 'Moments ago',
      fewMinutesAgo: 'A few minutes ago',
      isCanSendVoiceMessage:
        'The agent of transmissions with <i class="mdi mdi-volume-high text-blue mdi-22px"></i> displayed next to them is the voice transmission line.',
      markReadAllNotifications: 'Mark read all notifications',
      sendTicketToSupport: 'Send ticket to support',
      statisticsDoughnutChartText: 'Total number of text messages sent.',
      statisticsBarChartText:
        'The number of text messages sent based on the time of sending.',
      clipBoardAndFileUploadWarning:
        'Note that it is not possible to use <b>file upload</b> and <b>clipboard</b> modes in combination. <br> <br> Information is recorded in <b class="text-danger">{{modeWithDataTitle}}</b> mode. By going to <b class="text-danger">{{modeTitle} mode }</b> This information will be deleted. However, you are safe to go into <b class="text-danger">{{modeTitle}}</b> mode',
      minlengthValidationError:
        '{{title}} length should not be less than {{minLength}} digits.',
      maxlengthValidationError:
        '{{title}} must not exceed {{maxLength}} digits.',
      minValidationError: '{{title}} must not be less than {{min}}.',
      maxValidationError: '{{title}} must not exceed {{max}}.',
      minNumberValidationError: '{{title}} must not be less than {{min}}.',
      maxNumberValidationError: '{{title}} must not exceed {{max}}.',
      maxMobileNumbers:
        'You can register a maximum of .{{maxMobileNumbers}}mobile numbers',
      maxMobileNumbersInManualMode:
        'In manual mode, you can register a maximum of {{maxMobileNumbersInManualMode}} mobile numbers.',
      maxMobileNumbersInClipBoardMode:
        'In clip board mode, you can register a maximum of {{maxMobileNumbersInClipBoardMode}} mobile numbers.',
      deleteMessage: 'Are you sure you want to delete this item?',
      deleteMenuMessage: 'Are you sure you want to delete this menu?',
      deleteEndPointMessage: 'Are you sure you want to delete this endpoint?',
      confirmByWritingTextMessage:
        'By deleting this item, all subcategories and associated saved data will be deleted',
      confirmByWritingTextMessageForStopSending: 'Sending will stop',
      cellListMessage:
        'The following operators are supported in the selected area, if the operator you want is not in the list below, it is suggested to change or enlarge your coordinates.',
      confirmText: 'Confirm text',
      confirmPayment: 'Confirm payment',
      rejectPayment: 'Reject payment',
      rejectSend: 'Are you sure to reject this send?',
      allExcelReport: 'All excel report',
      pageExcelReport: 'Page excel report',
      pageTxtReport: 'Page text report',
      allTxtReport: 'All text report',
      changePasswordMsg:
        'Dear user, you need to change your password to keep your account safe',
      verificationCodeIsInvalid: 'The verification code is invalid',
      textMaxLength: 'Text max length',
      textMaxLengthInManualMode: 'Text max length in manual mode',
      textMaxCorrectMobileNumberCountInManualMode:
        'Text max correct mobile number count in manual mode',
      validMediaTypes: 'Valid media file types',
      successfulOperation: 'Successful operation',
      periodDateTimeErrorMsg:
        'When the start date and end date are equal, the start time cannot be greater than the end time.',
      failedOperation: 'Failed operation',
      OptimalSearch: 'Optimal search',
      currencyAlert: 'Currency alert',
      contentIsInvalid: 'Content is invalid',
      searchInOrganizations: 'Search in organizations',
      searchInRoles: 'Search in roles',
      insertMobile: 'Insert mobile',
      searchAggregator: 'Please enter the mobile number and then click search',
      isValidNumber: 'Please enter the mobile number and then click confirm',
      searchInUsers: 'Search in users',
      searchInPrivateNumbers: 'Search in private numbers',
      searchInPhonebooks: 'Search in the phone book',
      searchInContacts: 'Search contacts',
      searchInTargetPrivateNumbers: 'Search target private numbers',
      searchText: 'Search Text',
      enterSocialnetworkIdPlaceHolder: 'Enter Id',
      showSearch: 'Show search',
      isAddSignature: 'Is add signature',
      quitMsg: 'Do you want to log out of your account?',
      hideSearch: 'Close the filters',
      imageNotUploaded: 'Image not uploaded',
      fileNotUploaded: 'File not uploaded',
      fileIsInvalid: 'File is invalid',
      maxIpTotalCount: '*You can choose a maximum of 15 IPs',
      noExistOrganization: 'No exist organization',
      filterByGroup: 'Filter by group',
      updateCreditMessage: 'Click to update credit',
      separateByEnter: 'Separator with enter key',
      separateByCommaAndEnter: 'Delimiter with comma or enter key',
      removeContactFromAllPhonebook: 'Removed from all groups',
      chipListPlaceholder: 'Delimiter with comma or enter key',
      confirmPassword: 'Password and repassword doesnt match!',
      invalidDateErrorMsg: 'This service has expired.',
      invalidDateErrorMsgInSend:
        'Dear user, the registered date or time of sending has expired. To send SMS, reset the date and time of sending.',
      invalidMinDate:
        'The date must be greater than the current date or equal to the previously selected date',
      maxOpenTab: 'Max open tab',
      unblockUserMessage: 'Are you sure to unblock this user?',
      noConnectionToServer: 'No connection to server',
      notOrganization: 'Not organization',
      expired: 'Expired',
      notActiveOrganization: 'Not active organization',
      expireOrganization: 'Expired organization',
      globalConfirmationMessage: 'Are you sure about this operation?',
      archiveConfirmationMessage: 'Are you sure to archive this item?',
      notAuthenticated: 'Not authenticated',
      fullTextDisplay: 'Full text display',
      clickToSeeMore: 'Click to see more',
      resendMessageConfirmation: 'Resend message confirmation',
      groupDeletionConfirmation: 'Group deletion confirmation',
      deleteAllContactConfirmation: 'Delete all Contact confirmation',
      apiTokenconfirmation: 'Are you sure to approve this token?',
      apiTokenUndoconfirmation: 'Are you sure that this token is not approved?',
      selectItems: 'Select items',
      eventTitle: 'There is no explanation for this occasion',
      mapHelp:
        '<b>map tools</b> </br> Zoom in (enlarge the map)</br> zoom out (shrink the map) </br> register coordinates (register the selected area) </br> polygon tool ( The tool for selecting the range on the map, which requires at least 3 points to be selected to determine the range) </br> delete (delete the selected range) </br> To edit, click on the selected range and limit it by the points that appear. edit the </br> You can also add more areas (points) to your area by selecting the middle points',
      excelColListError: 'Excel col list error',
      notRegistered: 'Not registered',
      notLoggedIn: 'Not logged in',
      isValidIfConditionType: 'Is valid if condition type',
      isInvalidNumber: 'Invalid number',
      forgetPassword: 'Forget password',
      passwordRole: 'Password role',
      minLength:
        'The length of {{formFieldName}} must not be less than {{minLength}} characters.',
      selectFileFromFileManager: 'Please select a file',
      loginImage: 'Uploading login page images:',
      emptyWordList: 'The word list is empty',
      notSelectAnyOrganization: 'No organization selected',
      ifNumberIsNotServiceSmsWillNotBeSentToBlackList:
        'If number is not service SMS will not be sent to blacklist',
      deActiveAuthentication:
        'If you continue to edit, {{userName}} authentication will be disabled and the administrator must confirm {{userName}} account again. are you sure?',
      selectPrivateNumberForPhonebooks: 'Select private number for phonebooks',
      selectOrganizationForRoles: 'Select the organization to view the roles.',
      contactImportFromExcelMaxLength:
        'The maximum number of users allowed to register is {{maxLength}}.',
      inGroup: 'In group',
      requiredUserIds: 'User id is required',
      requiredPrivateNumbers: 'Required private numbers',
      requiredMsg: 'At least one selection is required.',
      deleteFromPhonebooks:
        'Please note that if the entered mobile number exists in another group, if you select that group, the number being registered will not be added to the current group.',
      sendingSms: 'Sending SMS',
      creatingCampaign: 'Creating campaign',
      generateRandomPassword: 'Generate Random Password',
      calcSmsPrice: 'Calculating sending cost',
      pleaseWaiting: 'Please wait...',
      err404Msg: "sorry,we couldn'T find this page !",
      enterYourText: 'Enter your text',
      isExistFilePatch:
        '<p>Click on the play button to complete the text to audio conversion process.</p> <p>The audio file is required.</p>',
      maxReceiversMsg: 'You can add a maximum of {{number}} numbers.',
      statusListMsg: 'The situations that include this option are',
      onlyJpegAndPngAreAllowed:
        'Only files with the extension jpeg, jpg, png are allowed',
      maxSizeIs1mb: 'The maximum size of each file should not exceed 1 MB',
      receiversExcel: 'Please enter the title of the Excel file',
      successfulPurchase: 'Your purchase was successful',
      successfulDiscount: 'The discount code has been applied successfully',
      notEnoughCredit: 'Your credit is not enough',
      ruleConfirmation:
        'While carefully studying and being aware of the terms and conditions, I made the purchase and accepted the terms',
      privateNumberPurchaseRulesTitr:
        'The content of text messages must comply with the following principles and rules',
      organizationInfo: 'Organization Info',
      userInfo: 'User Info',
      planInfo: 'Plan Info',
      daysLeftUntilExpires: 'Days left until expires',
      buyPlanUserInfoNotice:
        'Dear user, in order to buy a plan, you must be registered on the site. If you have already registered, log in to your account.',
      enterAuthCode: 'Enter the verification code',
      cancelRequest:
        '<span>Your request is being processed,<br>It may take some time.</span>',
      noTextForShow: 'There is no text for display!',
      sendersListAlert:
        '<span><p>● Dear user, to view the senders, you can enter your desired option first.</br>● If you have not selected any option, the list of all senders will be displayed.</p></span>',
      lotteryAlert:
        '<span> Dear user, you can choose the option you want for the lottery, so that the lottery will take place among the people who have chosen this option.</span>',
      lotteryNotStart:
        'In order to do the lottery, specify the number of winners, then click on the lottery button.',
      addToQueue: 'Are you sure to add this message to queue?',
      getCurrentIpHelp1: '* You can use',
      getCurrentIpHelp2: 'To get the current IP',
      wrongIndex: 'Wrong index',
      rangeDetail:
        'Be careful to choose a digit larger than the last digit of the IP address for the IP range',
      selectPolygon: 'Please select a polygon.',
      disableMapInSmartSms:
        'In this type of smart sending request, selecting the range from the map is disabled',
      disableMapInSmartSmsDetail:
        'In this type of smart sending request, the map is disabled',
      smartPeriodicMessage:
        'Dear user, please note that if you select more than one region, the number of submissions you enter in the relevant field will be considered separately for each region.',
      socialMediaSizeRangeMessage: 'File size based on Kilobytes',
      dragFile: 'Drag or choose a file',
      pasteInfinite: 'Click on the button to insert infinity.',
      mapOfTheCampaignLocation: 'Map of the campaign location',
      TheNumberOfSMSSentByOperator: 'The number of SMS sent by operator',
      theNumberOfSMSSentByStatus: 'The number of SMS sent by status',
      smsBodyContainsHeaderOrSignature: 'Sms body contains header or signature',
      clickToShowFile: 'Click to show full file',
      forbiddenCharacters:
        'Using {{forbiddenCharacters}} characters are forbidden in sms text',
      activePeriodicSmartSmsRequestsDescription:
        'The following table displays the list of the latest active campaigns running by the user',
      isUseSeparatorChangeMessage:
        'By changing this option, the page will be reloaded',
      reversePolygonAlert:
        'If you do not need the current coordinate on map please delete it and then use the reverse polygon',
      noCellMessage: 'No cell in the area with selected operator',
      wrongCellList: 'Cell list is wrong',
      emptyMobileNumbers: 'Mobile numbers list is empty',
      periodicPatterns:
        'The list of templates is provided below, you can choose the template of the desired day.',
      changePeriodicPatterns:
        'Note that all selected days will be deleted if the pattern is changed.',
      choosePeriodicPattern: 'Choose periodic pattern',
      showCalender:
        'Click on the calendar display button to select the template and sending days.',
      chooseDaysFromCalender:
        'In order to display and select the sending days, click on the calendar display button.',
      defaultDaysOfWeekIsSelected:
        'By default, all days of the week of the selected period are considered',
      rejectUserSafeIp: 'Are you sure to reject ip? ',
      confirmUserSafeIp: 'Are you sure to confirm ip?',
      useTag:
        'If you wish to use a tag, please enclose it in parentheses. For example: (p)',
      searchInModels: 'Search in models are case sensitive.',
      isForceSearch: 'To get result in this menu, please search items first.',
      selectNumberFirst: 'Select number first',
      patternFieldHint:
        'Please use regex without / in this field. For example: ^d+$',
      bulkRecipientsLimitation: 'Selected areas should lower than {{count}}.',
      changeThenConditionTypeMessage: 'changeThenConditionTypeMessage',
      smartSignatureMessage: 'Smart signature message',
      forbiddenVoiceAndSocialSend: 'Forbidden voice and social send',
      clipBoardAndManualCells: 'clipBoardAndManualCells ',
      namesRegistered: 'names registered',
      outboxAdvancedSearchHelp: 'Outbox advanced search help',
    },
    components: {
      mobilesAnalysis: {
        addTitle: 'Add to blacklist',
        wrongMobileNumbers: 'Wrong mobile numbers',
        listOfMobileNumbers: 'List of mobile numbers',
        alertPart1: 'Maximum show count is {{ size }}, for show more numbers',
        alertPart2: 'Click',
        downloadText: 'Download text file',
        downloadExcel: 'Download excel file',
        correctNumbers: 'Correct numbers',
        wrongNumbers: 'Wrong numbers',
        manualAddDescription:
          '<p class="tw-mt-3 tw-mb-1">⁃To add manually, you can enter the desired mobile numbers in the field below.</p><p class="tw-my-1">⁃ This service intelligently checks and registers the correct mobile numbers, and also displays invalid or incorrectly typed items as errors in the (wrong numbers) section.</p> <p class="tw-my-1 text-danger tw-font-medium">⁃Note that duplicate mobile numbers will be deleted.</p><p class="tw-my-1">⁃It should be noted that in manual mode you can maximum register<b> {{number}} </b>mobile numbers </p><p class="tw-my-1">⁃It is recommended to use the <span class="text-info tw-font-medium"> {{clipBoard}} </span> to insert large volumes of text</p>',
        uploadAddDescription:
          '<p class="tw-mt-3 tw-mb-1">⁃Files with types<b>{{fileTypes}}</b> are allowed to upload.</p><p class="tw-my-1">⁃The maximum file size allowed for uploading<b> {{maxFileSize}} mb </b>.</p><p class="tw-my-1">⁃Please note that the first line of the Excel file is not read, so you should use it to insert the title.</p><p class="tw-my-1">⁃Column titles should be text type with English letters.</p><p class="tw-my-1">⁃To get a sample file<a class="tw-font-bold tw-cursor-pointer text-info" href="/assets/media/sample/sample.xlsx"download="sampleMobiles.xlsx" id="linkIdSampleMobiles"> here  </a> click </p><p class="tw-my-1 text-danger tw-font-medium">⁃Note that duplicate mobile numbers will be deleted.</p><p class="tw-my-1">⁃It should be noted that you can maximum register<b> {{maxMobileNumbers}} </b> mobile numbers.</p>',
        clipBoardAddDescription:
          '<p class="tw-mt-3 tw-mb-1">⁃To add a mobile number, you can (paste) the numbers in the clipboard in the field below.</p><p class="tw-my-1">⁃This service intelligently checks and registers correct mobile numbers, and also displays invalid or incorrectly typed items as errors in the (wrong numbers) section.</p><p class="tw-my-1 text-danger tw-font-medium">⁃Note that duplicate mobile numbers will be deleted.</p><p class="tw-my-1">⁃It should be noted that in the clipboard mode, you can maximum register<b> {{maxMobileNumbers}} </b>mobile numbers.</p>',
        pasteNumber:
          'Paste your numbers here by pressing <span class="text-primary tw-text-[13px] tw-font-semibold"> (Ctrl + V) </span> or clicking on the key <i class="mdi mdi-clipboard-arrow-down-outline text-primary mdi-18px tw-mt-1"></i>.',
        numberRegistered:
          '<span class="text-success"><b class="tw-text-[14px] tw-font-black">{{mobileNumbersCountInClipboardMode}}</b> number registered .</span>To view <span class="tw-font-medium">{{downloadFile}}<i class="mdi mdi-tray-arrow-down mdi-18px text-gray"></i></span> click on download file.',
      },
      dynamicGrid: {
        props: {
          fromIndex: 'From index',
          sendCount: 'Send count',
          Count: 'Count',
          age: 'Age',
        },
        smartSendConfirmation: {
          sendProperties: 'Send properties',
          price: ' The amount of each SMS ',
          irr: 'Rial',
          polygonCalculatedPrice: 'Shopping cost range  ',
          sendTotalPrice: 'Total cost',
          sendTotalPriceDesc: 'The cost is estimated based on a text message',
          NextStep: 'Send SMS ',
        },
        domainForm: {
          imageUploaderHelpForLoginWithCarousel:
            '<p class="tw-mt-3 tw-mb-1 tw-text-base"> ⁃ The uploaded image must be in <b>jpg ، png and jpeg </b> format .</p> <p class="tw-my-3 tw-text-base"> ⁃ It is recommended that the image size be <b>4006px * 2116px</b></p> <p class="tw-my-3 tw-text-base"> ⁃The margins of the image should be <b>378px</b> from the top and bottom, and <b>756px</b> from the right and left .</p><p class="tw-my-3 tw-text-base">⁃ The maximum file size for the image is <b>1MB</b>.</p>',
          imageUploaderHelpForRightOrCenterLogin:
            '<p class="tw-mt-3 tw-mb-1 tw-text-base"> ⁃ The uploaded image must be in <b>jpg ، png and jpeg </b> format .</p> <p class="tw-my-3 tw-text-base"> ⁃ It is recommended that the image size be <b>1133px * 604px</b> </p><p class="tw-my-3 tw-text-base">⁃ The maximum file size for the image is <b>1MB</b>.</p>',
        },
      },
    },
    shared: {
      components: {
        smsTemplateModal: {
          chooseTemplate:
            'By pressing the <span class="text-info tw-font-bold">Select</span> key, you can select a template as the text of the message.',
        },
      },
    },
  },
};
